const ActionSelectorReduxActionTypes = {
  EVALUATE_ACTION_SELECTOR_FIELD: "EVALUATE_ACTION_SELECTOR_FIELD",
  SET_EVALUATED_ACTION_SELECTOR_FIELD: "SET_EVALUATED_ACTION_SELECTOR_FIELD",
  CLEAR_EVALUATED_ACTION_SELECTOR_FIELD:
    "CLEAR_EVALUATED_ACTION_SELECTOR_FIELD",
};

const ResourceMapActionTypes = {
  SET_PAGE_RESOURCE_MAPS: "SET_PAGE_RESOURCE_MAPS",
  RESET_ALL_RESOURCE_MAPS: "RESET_ALL_RESOURCE_MAPS",
};

const JSLibraryActionTypes = {
  TOGGLE_INSTALLER: "TOGGLE_INSTALLER",
  FETCH_JS_LIBRARIES_INIT: "FETCH_JS_LIBRARIES_INIT",
  FETCH_JS_LIBRARIES_SUCCESS: "FETCH_JS_LIBRARIES_SUCCESS",
  CLEAR_PROCESSED_INSTALLS: "CLEAR_PROCESSED_INSTALLS",
  INSTALL_LIBRARY_INIT: "INSTALL_LIBRARY_INIT",
  INSTALL_LIBRARY_START: "INSTALL_LIBRARY_START",
  INSTALL_LIBRARY_SUCCESS: "INSTALL_LIBRARY_SUCCESS",
  UNINSTALL_LIBRARY_INIT: "UNINSTALL_LIBRARY_INIT",
  UNINSTALL_LIBRARY_SUCCESS: "UNINSTALL_LIBRARY_SUCCESS",
};

const JSLibraryActionErrorTypes = {
  INSTALL_LIBRARY_FAILED: "INSTALL_LIBRARY_FAILED",
  UNINSTALL_LIBRARY_FAILED: "UNINSTALL_LIBRARY_FAILED",
  FETCH_JS_LIBRARIES_FAILED: "FETCH_JS_LIBRARIES_FAILED",
};

const JSEditorActionTypes = {
  START_EXECUTE_JS_FUNCTION: "START_EXECUTE_JS_FUNCTION",
  EXECUTE_JS_UPDATES: "EXECUTE_JS_UPDATES",
  FETCH_JS_ACTIONS_INIT: "FETCH_JS_ACTIONS_INIT",
  FETCH_JS_ACTIONS_SUCCESS: "FETCH_JS_ACTIONS_SUCCESS",
  UPDATE_TEST_PAYLOAD_FOR_COLLECTION: "UPDATE_TEST_PAYLOAD_FOR_COLLECTION",
  UPDATE_TEST_PAYLOAD_FOR_JS_ACTION: "UPDATE_TEST_PAYLOAD_FOR_JS_ACTION",
  JS_ACTION_REMOTE_EXECUTION_INIT: "JS_ACTION_REMOTE_EXECUTION_INIT",
  CREATE_NEW_JS_ACTION: "CREATE_NEW_JS_ACTION",
  CREATE_JS_ACTION_INIT: "CREATE_JS_ACTION_INIT",
  CREATE_JS_ACTION_SUCCESS: "CREATE_JS_ACTION_SUCCESS",
  COPY_JS_ACTION_INIT: "COPY_JS_ACTION_INIT",
  COPY_JS_ACTION_SUCCESS: "COPY_JS_ACTION_SUCCESS",
  MOVE_JS_ACTION_INIT: "MOVE_JS_ACTION_INIT",
  MOVE_JS_ACTION_SUCCESS: "MOVE_JS_ACTION_SUCCESS",
  DELETE_JS_ACTION_INIT: "DELETE_JS_ACTION_INIT",
  DELETE_JS_ACTION_SUCCESS: "DELETE_JS_ACTION_SUCCESS",
  PARSE_UPDATE_JS_ACTION: "PARSE_UPDATE_JS_ACTION",
  UPDATE_JS_ACTION_SUCCESS: "UPDATE_JS_ACTION_SUCCESS",
  JS_ACTION_SAVE_START: "JS_ACTION_SAVE_START",
  JS_ACTION_SAVE_COMPLETE: "JS_ACTION_SAVE_COMPLETE",
  EXECUTE_COMMAND: "EXECUTE_COMMAND",
  SAVE_JS_COLLECTION_NAME_INIT: "SAVE_JS_COLLECTION_NAME_INIT",
  FETCH_JS_ACTIONS_FOR_PAGE_INIT: "FETCH_JS_ACTIONS_FOR_PAGE_INIT",
  FETCH_JS_ACTIONS_FOR_PAGE_SUCCESS: "FETCH_JS_ACTIONS_FOR_PAGE_SUCCESS",
  SAVE_JS_COLLECTION_NAME_SUCCESS: "SAVE_JS_COLLECTION_NAME_SUCCESS",
  EXECUTE_JS_FUNCTION_INIT: "EXECUTE_JS_FUNCTION_INIT",
  EXECUTE_JS_FUNCTION_SUCCESS: "EXECUTE_JS_FUNCTION_SUCCESS",
  SET_JS_FUNCTION_EXECUTION_DATA: "SET_JS_FUNCTION_EXECUTION_DATA",
  SET_JS_FUNCTION_EXECUTION_ERRORS: "SET_JS_FUNCTION_EXECUTION_ERRORS",
  REFACTOR_JS_ACTION_NAME: "REFACTOR_JS_ACTION_NAME",
  REFACTOR_JS_ACTION_NAME_SUCCESS: "REFACTOR_JS_ACTION_NAME_SUCCESS",
  UPDATE_JS_ACTION_BODY: "UPDATE_JS_ACTION_BODY",
  UPDATE_JS_ACTION_BODY_INIT: "UPDATE_JS_ACTION_BODY_INIT",
  UPDATE_JS_ACTION_BODY_SUCCESS: "UPDATE_JS_ACTION_BODY_SUCCESS",
  SET_FUNCTION_PROPERTY: "SET_FUNCTION_PROPERTY",
  UPDATE_JS_FUNCTION_PROPERTY_INIT: "UPDATE_JS_FUNCTION_PROPERTY_INIT",
  UPDATE_JS_FUNCTION_PROPERTY_SUCCESS: "UPDATE_JS_FUNCTION_PROPERTY_SUCCESS",
  SET_JS_ACTION_RUN_BEHAVIOR: "SET_JS_ACTION_RUN_BEHAVIOR",
  SET_ACTIVE_JS_ACTION: "SET_ACTIVE_JS_ACTION",
  UPDATE_FUNCTION_RUN_BEHAVIOR_INIT: "UPDATE_FUNCTION_RUN_BEHAVIOR_INIT",
  UPDATE_FUNCTION_RUN_BEHAVIOR_SUCCESS: "UPDATE_FUNCTION_RUN_BEHAVIOR_SUCCESS",
};

const JSEditorActionErrorTypes = {
  FETCH_JS_ACTIONS_ERROR: "FETCH_JS_ACTIONS_ERROR",
  CREATE_JS_ACTION_ERROR: "CREATE_JS_ACTION_ERROR",
  UPDATE_JS_ACTION_ERROR: "UPDATE_JS_ACTION_ERROR",
  COPY_JS_ACTION_ERROR: "COPY_JS_ACTION_ERROR",
  MOVE_JS_ACTION_ERROR: "MOVE_JS_ACTION_ERROR",
  SAVE_JS_COLLECTION_NAME_ERROR: "SAVE_JS_COLLECTION_NAME_ERROR",
  FETCH_JS_ACTIONS_FOR_PAGE_ERROR: "FETCH_JS_ACTIONS_FOR_PAGE_ERROR",
  DELETE_JS_ACTION_ERROR: "DELETE_JS_ACTION_ERROR",
  REFACTOR_JS_ACTION_NAME_ERROR: "REFACTOR_JS_ACTION_NAME_ERROR",
  UPDATE_JS_ACTION_BODY_ERROR: "UPDATE_JS_ACTION_BODY_ERROR",
  UPDATE_JS_FUNCTION_PROPERTY_ERROR: "UPDATE_JS_FUNCTION_PROPERTY_ERROR",
  UPDATE_FUNCTION_RUN_BEHAVIOR_ERROR: "UPDATE_FUNCTION_RUN_BEHAVIOR_ERROR",
};

const GitActionTypes = {
  GIT_DISCARD_CHANGES_SUCCESS: "GIT_DISCARD_CHANGES_SUCCESS",
  GIT_DISCARD_CHANGES: "GIT_DISCARD_CHANGES",
  CLEAR_DISCARD_ERROR_STATE: "CLEAR_DISCARD_ERROR_STATE",
  DELETE_BRANCH_INIT: "DELETE_BRANCH_INIT",
  DELETING_BRANCH: "DELETING_BRANCH",
  DELETE_BRANCH_SUCCESS: "DELETE_BRANCH_SUCCESS",
  RESET_SSH_KEY_PAIR: "RESET_SSH_KEY_PAIR",
  GIT_INFO_INIT: "GIT_INFO_INIT",
  REVOKE_GIT: "REVOKE_GIT",
  SHOW_CONNECT_GIT_MODAL: "SHOW_CONNECT_GIT_MODAL",
  SET_SHOULD_SHOW_REPO_LIMIT_ERROR_MODAL:
    "SET_SHOULD_SHOW_REPO_LIMIT_ERROR_MODAL",
  SET_SHOULD_SHOW_DISCONNECT_GIT_MODAL: "SET_SHOULD_SHOW_DISCONNECT_GIT_MODAL",
  RESET_PULL_MERGE_STATUS: "RESET_PULL_MERGE_STATUS",
  GIT_PULL_INIT: "GIT_PULL_INIT",
  GIT_PULL_SUCCESS: "GIT_PULL_SUCCESS",
  CLEAR_COMMIT_ERROR_STATE: "CLEAR_COMMIT_ERROR_STATE",
  CLEAR_COMMIT_SUCCESSFUL_STATE: "CLEAR_COMMIT_SUCCESSFUL_STATE",
  FETCH_MERGE_STATUS_INIT: "FETCH_MERGE_STATUS_INIT",
  FETCH_MERGE_STATUS_SUCCESS: "FETCH_MERGE_STATUS_SUCCESS",
  RESET_MERGE_STATUS: "RESET_MERGE_STATUS",
  MERGE_BRANCH_INIT: "MERGE_BRANCH_INIT",
  MERGE_BRANCH_SUCCESS: "MERGE_BRANCH_SUCCESS",
  FETCH_GIT_STATUS_INIT: "FETCH_GIT_STATUS_INIT",
  FETCH_GIT_STATUS_SUCCESS: "FETCH_GIT_STATUS_SUCCESS",
  UPDATE_BRANCH_LOCALLY: "UPDATE_BRANCH_LOCALLY",
  FETCH_BRANCHES_INIT: "FETCH_BRANCHES_INIT",
  FETCH_BRANCHES_SUCCESS: "FETCH_BRANCHES_SUCCESS",
  FETCH_SSH_KEY_PAIR_INIT: "FETCH_SSH_KEY_PAIR_INIT",
  INIT_SSH_KEY_PAIR_WITH_NULL: "INIT_SSH_KEY_PAIR_WITH_NULL",
  FETCH_SSH_KEY_PAIR_SUCCESS: "FETCH_SSH_KEY_PAIR_SUCCESS",
  SET_IS_IMPORT_APP_VIA_GIT_MODAL_OPEN: "SET_IS_IMPORT_APP_VIA_GIT_MODAL_OPEN",
  FETCH_GLOBAL_GIT_CONFIG_INIT: "FETCH_GLOBAL_GIT_CONFIG_INIT",
  FETCH_GLOBAL_GIT_CONFIG_SUCCESS: "FETCH_GLOBAL_GIT_CONFIG_SUCCESS",
  UPDATE_GLOBAL_GIT_CONFIG_INIT: "UPDATE_GLOBAL_GIT_CONFIG_INIT",
  UPDATE_GLOBAL_GIT_CONFIG_SUCCESS: "UPDATE_GLOBAL_GIT_CONFIG_SUCCESS",
  FETCH_LOCAL_GIT_CONFIG_INIT: "FETCH_LOCAL_GIT_CONFIG_INIT",
  FETCH_LOCAL_GIT_CONFIG_SUCCESS: "FETCH_LOCAL_GIT_CONFIG_SUCCESS",
  UPDATE_LOCAL_GIT_CONFIG_INIT: "UPDATE_LOCAL_GIT_CONFIG_INIT",
  UPDATE_LOCAL_GIT_CONFIG_SUCCESS: "UPDATE_LOCAL_GIT_CONFIG_SUCCESS",
  SHOW_CREATE_GIT_BRANCH_POPUP: "SHOW_CREATE_GIT_BRANCH_POPUP",
  SHOW_ERROR_POPUP: "SHOW_ERROR_POPUP",
  CONNECT_TO_GIT_INIT: "CONNECT_TO_GIT_INIT",
  CONNECT_TO_GIT_SUCCESS: "CONNECT_TO_GIT_SUCCESS",
  CREATE_NEW_BRANCH_INIT: "CREATE_NEW_BRANCH_INIT",
  SWITCH_GIT_BRANCH_INIT: "SWITCH_GIT_BRANCH_INIT",
  SWITCH_GIT_BRANCH_SUCCESS: "SWITCH_GIT_BRANCH_SUCCESS",
  SWITCH_GIT_BRANCH_ERROR: "SWITCH_GIT_BRANCH_ERROR",
  COMMIT_TO_GIT_REPO_INIT: "COMMIT_TO_GIT_REPO_INIT",
  COMMIT_TO_GIT_REPO_SUCCESS: "COMMIT_TO_GIT_REPO_SUCCESS",
  PUSH_TO_GIT_INIT: "PUSH_TO_GIT_INIT",
  PUSH_TO_GIT_SUCCESS: "PUSH_TO_GIT_SUCCESS",
  SET_IS_GIT_SYNC_MODAL_OPEN: "SET_IS_GIT_SYNC_MODAL_OPEN",
  GIT_UPDATE_DEFAULT_BRANCH_INIT: "GIT_UPDATE_DEFAULT_BRANCH_INIT",
  GIT_UPDATE_DEFAULT_BRANCH_SUCCESS: "GIT_UPDATE_DEFAULT_BRANCH_SUCCESS",
  GIT_UPDATE_DEFAULT_BRANCH_ERROR: "GIT_UPDATE_DEFAULT_BRANCH_ERROR",
  GIT_FETCH_PROTECTED_BRANCHES_INIT: "GIT_FETCH_PROTECTED_BRANCHES_INIT",
  GIT_FETCH_PROTECTED_BRANCHES_SUCCESS: "GIT_FETCH_PROTECTED_BRANCHES_SUCCESS",
  GIT_FETCH_PROTECTED_BRANCHES_ERROR: "GIT_FETCH_PROTECTED_BRANCHES_ERROR",
  GIT_UPDATE_PROTECTED_BRANCHES_INIT: "GIT_UPDATE_PROTECTED_BRANCHES_INIT",
  GIT_UPDATE_PROTECTED_BRANCHES_SUCCESS:
    "GIT_UPDATE_PROTECTED_BRANCHES_SUCCESS",
  GIT_UPDATE_PROTECTED_BRANCHES_ERROR: "GIT_UPDATE_PROTECTED_BRANCHES_ERROR",
  GIT_SET_IS_AUTOCOMMIT_MODAL_OPEN: "GIT_SET_AUTOCOMMIT_MODAL_OPEN",
  GIT_TOGGLE_AUTOCOMMIT_ENABLED_INIT: "GIT_TOGGLE_AUTOCOMMIT_ENABLED_INIT",
  GIT_TOGGLE_AUTOCOMMIT_ENABLED_SUCCESS:
    "GIT_TOGGLE_AUTOCOMMIT_ENABLED_SUCCESS",
  GIT_AUTOCOMMIT_TRIGGER_INIT: "GIT_AUTOCOMMIT_TRIGGER_INIT",
  GIT_AUTOCOMMIT_TRIGGER_SUCCESS: "GIT_AUTOCOMMIT_TRIGGER_SUCCESS",
  GIT_AUTOCOMMIT_START_PROGRESS_POLLING:
    "GIT_AUTOCOMMIT_START_PROGRESS_POLLING",
  GIT_AUTOCOMMIT_STOP_PROGRESS_POLLING: "GIT_AUTOCOMMIT_STOP_PROGRESS_POLLING",
  GIT_SET_AUTOCOMMIT_PROGRESS: "GIT_SET_AUTOCOMMIT_PROGRESS",
  GIT_RESET_AUTOCOMMIT_PROGRESS: "GIT_RESET_AUTOCOMMIT_PROGRESS",
  GIT_GET_METADATA_INIT: "GIT_GET_METADATA_INIT",
  GIT_GET_METADATA_SUCCESS: "GIT_GET_METADATA_SUCCESS",
  GIT_SHOW_BRANCH_POPUP: "GIT_SHOW_BRANCH_POPUP",
  GIT_SET_SETTINGS_MODAL_OPEN: "GIT_SET_SETTINGS_MODAL_OPEN",
  GENERATE_SSH_KEY_PAIR_INIT: "GENERATE_SSH_KEY_PAIR_INIT",
  SET_REMOTE_URL_INPUT_VALUE: "SET_REMOTE_URL_INPUT_VALUE",
  GENERATE_SSH_KEY_PAIR_SUCCESS: "GENERATE_SSH_KEY_PAIR_SUCCESS",
  SET_PROTECTED_MODE: "SET_PROTECTED_MODE",
  SET_DISCONNECTING_GIT_APPLICATION: "SET_DISCONNECTING_GIT_APPLICATION",
};

const GitActionErrorTypes = {
  GIT_DISCARD_CHANGES_ERROR: "GIT_DISCARD_CHANGES_ERROR",
  DELETE_BRANCH_WARNING: "DELETE_BRANCH_WARNING",
  DELETE_BRANCH_ERROR: "DELETE_BRANCH_ERROR",
  GIT_PULL_ERROR: "GIT_PULL_ERROR",
  FETCH_MERGE_STATUS_ERROR: "FETCH_MERGE_STATUS_ERROR",
  MERGE_BRANCH_ERROR: "MERGE_BRANCH_ERROR",
  FETCH_GIT_STATUS_ERROR: "FETCH_GIT_STATUS_ERROR",
  CREATE_NEW_BRANCH_ERROR: "CREATE_NEW_BRANCH_ERROR",
  CHECKOUT_BRANCH_ERROR: "CHECKOUT_BRANCH_ERROR",
  FETCH_BRANCHES_ERROR: "FETCH_BRANCHES_ERROR",
  FETCH_LOCAL_GIT_CONFIG_ERROR: "FETCH_LOCAL_GIT_CONFIG_ERROR",
  UPDATE_LOCAL_GIT_CONFIG_ERROR: "UPDATE_LOCAL_GIT_CONFIG_ERROR",
  PUSH_TO_GIT_ERROR: "PUSH_TO_GIT_ERROR",
  FETCH_SSH_KEY_PAIR_ERROR: "FETCH_SSH_KEY_PAIR_ERROR",
  UPDATE_GLOBAL_GIT_CONFIG_ERROR: "UPDATE_GLOBAL_GIT_CONFIG_ERROR",
  FETCH_GLOBAL_GIT_CONFIG_ERROR: "FETCH_GLOBAL_GIT_CONFIG_ERROR",
  CONNECT_TO_GIT_ERROR: "CONNECT_TO_GIT_ERROR",
  DISCONNECT_TO_GIT_ERROR: "DISCONNECT_TO_GIT_ERROR",
  COMMIT_TO_GIT_REPO_ERROR: "COMMIT_TO_GIT_REPO_ERROR",
  GIT_TOGGLE_AUTOCOMMIT_ENABLED_ERROR: "GIT_TOGGLE_AUTOCOMMIT_ENABLED_ERROR",
  GIT_AUTOCOMMIT_PROGRESS_POLLING_ERROR:
    "GIT_AUTOCOMMIT_PROGRESS_POLLING_ERROR",
  GIT_AUTOCOMMIT_TRIGGER_ERROR: "GIT_AUTOCOMMIT_TRIGGER_ERROR",
  GIT_GET_METADATA_ERROR: "GIT_GET_METADATA_ERROR",
};

const ImportExportActionTypes = {
  SHOW_RECONNECT_DATASOURCE_MODAL: "SHOW_RECONNECT_DATASOURCE_MODAL",
  RESET_UNCONCONFIGURED_DATASOURCES_LIST_DURING_IMPORT:
    "RESET_UNCONCONFIGURED_DATASOURCES_LIST_DURING_IMPORT",
  RESET_DATASOURCE_CONFIG_FETCHED_FOR_IMPORT_FLAG:
    "RESET_DATASOURCE_CONFIG_FETCHED_FOR_IMPORT_FLAG",
  SET_UNCONFIGURED_DATASOURCES: "SET_UNCONFIGURED_DATASOURCES",
  SET_WORKSPACE_ID_FOR_IMPORT: "SET_WORKSPACE_ID_FOR_IMPORT",
  SET_PAGE_ID_FOR_IMPORT: "SET_PAGE_ID_FOR_IMPORT",
  UPDATE_DATASOURCE_IMPORT_SUCCESS: "UPDATE_DATASOURCE_IMPORT_SUCCESS",
  INIT_DATASOURCE_CONNECTION_DURING_IMPORT_REQUEST:
    "INIT_DATASOURCE_CONNECTION_DURING_IMPORT_REQUEST",
  INIT_DATASOURCE_CONNECTION_DURING_IMPORT_SUCCESS:
    "INIT_DATASOURCE_CONNECTION_DURING_IMPORT_SUCCESS",
  SET_IS_RECONNECTING_DATASOURCES_MODAL_OPEN:
    "SET_IS_RECONNECTING_DATASOURCES_MODAL_OPEN",
  PARTIAL_IMPORT_MODAL_OPEN: "PARTIAL_IMPORT_MODAL_OPEN",
  PARTIAL_IMPORT_INIT: "PARTIAL_IMPORT_INIT",
  PARTIAL_IMPORT_SUCCESS: "PARTIAL_IMPORT_SUCCESS",
  PARTIAL_EXPORT_MODAL_OPEN: "PARTIAL_EXPORT_MODAL_OPEN",
  PARTIAL_EXPORT_INIT: "PARTIAL_EXPORT_INIT",
  PARTIAL_EXPORT_SUCCESS: "PARTIAL_EXPORT_SUCCESS",
  IMPORT_APPLICATION_INIT: "IMPORT_APPLICATION_INIT",
  IMPORT_APPLICATION_FROM_GIT_INIT: "IMPORT_APPLICATION_FROM_GIT_INIT",
  IMPORT_APPLICATION_SUCCESS: "IMPORT_APPLICATION_SUCCESS",
  RESET_IMPORT_DATA: "RESET_IMPORT_DATA",
};

const ImportExportActionErrorTypes = {
  IMPORT_APPLICATION_ERROR: "IMPORT_APPLICATION_ERROR",
  PARTIAL_IMPORT_ERROR: "PARTIAL_IMPORT_ERROR",
  PARTIAL_EXPORT_ERROR: "PARTIAL_EXPORT_ERROR",
};

const ImportGitActionTypes = {
  IMPORT_APPLICATION_FROM_GIT_ERROR: "IMPORT_APPLICATION_FROM_GIT_ERROR",
  IMPORT_APPLICATION_FROM_GIT_SUCCESS: "IMPORT_APPLICATION_FROM_GIT_SUCCESS",
  IMPORT_APPLICATION_FROM_GIT_STATUS_RESET:
    "IMPORT_APPLICATION_FROM_GIT_STATUS_RESET",
};

const ExplorerActionTypes = {
  SET_ENTITY_INFO: "SET_ENTITY_INFO",
  INIT_EXPLORER_ENTITY_NAME_EDIT: "INIT_EXPLORER_ENTITY_NAME_EDIT",
  END_EXPLORER_ENTITY_NAME_EDIT: "END_EXPLORER_ENTITY_NAME_EDIT",
  SET_CANVAS_CARDS_STATE: "SET_CANVAS_TOP_SECTION_VISIBILITY",
  DELETE_CANVAS_CARDS_STATE: "DELETE_CANVAS_CARDS_STATE",
  UPDATE_EXPLORER_WIDTH: "UPDATE_EXPLORER_WIDTH",
};

const MetaEvaluationActionTypes = {
  UPDATE_META_STATE: "UPDATE_META_STATE",
  BATCH_UPDATE_META_PROPS: "BATCH_UPDATE_META_PROPS",
  SET_META_PROP: "SET_META_PROP",
  SET_META_PROP_AND_EVAL: "SET_META_PROP_AND_EVAL",
  META_UPDATE_DEBOUNCED_EVAL: "META_UPDATE_DEBOUNCED_EVAL",
  RESET_CHILDREN_WIDGET_META: "RESET_CHILDREN_WIDGET_META",
  RESET_WIDGET_META: "RESET_WIDGET_META",
  RESET_WIDGET_META_UPDATES: "RESET_WIDGET_META_UPDATES",
  RESET_WIDGET_META_EVALUATED: "RESET_WIDGET_META_EVALUATED",
  RESET_WIDGETS_META_STATE: "RESET_WIDGETS_META_STATE",
};

const EvaluationActionTypes = {
  ...MetaEvaluationActionTypes,
  SET_APP_VERSION_ON_WORKER: "SET_APP_VERSION_ON_WORKER",
  FETCH_ALL_PAGE_ENTITY_COMPLETION: "FETCH_ALL_PAGE_ENTITY_COMPLETION",
  SET_URL_DATA: "SET_URL_DATA",
  SET_APP_MODE: "SET_APP_MODE",
  UPDATE_APP_STORE: "UPDATE_APP_STORE",
  SET_EVALUATED_TREE: "SET_EVALUATED_TREE",
  SET_EVALUATION_INVERSE_DEPENDENCY_MAP:
    "SET_EVALUATION_INVERSE_DEPENDENCY_MAP",
  START_EVALUATION: "START_EVALUATION",
  SET_LOADING_ENTITIES: "SET_LOADING_ENTITIES",
  UPDATE_REPLAY_ENTITY: "UPDATE_REPLAY_ENTITY",
  SET_USER_CURRENT_GEO_LOCATION: "SET_USER_CURRENT_GEO_LOCATION",
  SET_LINT_ERRORS: "SET_LINT_ERRORS",
  LINT_TREE: "LINT_TREE",
  UPDATE_LINT_GLOBALS: "UPDATE_LINT_GLOBALS",
  RESET_DATA_TREE: "RESET_DATA_TREE",
  BUFFERED_ACTION: "BUFFERED_ACTION",
  CLEAR_CACHE: "CLEAR_CACHE",
  TRIGGER_EVAL: "TRIGGER_EVAL",
  UPDATE_ACTION_DATA: "UPDATE_ACTION_DATA",
  SET_ACTIVE_EDITOR_FIELD: "SET_ACTIVE_EDITOR_FIELD",
  RESET_ACTIVE_EDITOR_FIELD: "RESET_ACTIVE_EDITOR_FIELD",
  LINT_SETUP: "LINT_SETUP",
};

const EvaluationActionErrorTypes = {
  FAILED_CORRECTING_BINDING_PATHS: "FAILED_CORRECTING_BINDING_PATHS",
};

const OmniSearchActionTypes = {
  SET_SEARCH_FILTER_CONTEXT: "SET_SEARCH_FILTER_CONTEXT",
  SET_GLOBAL_SEARCH_QUERY: "SET_GLOBAL_SEARCH_QUERY",
  SET_GLOBAL_SEARCH_CATEGORY: "SET_GLOBAL_SEARCH_CATEGORY",
  TOGGLE_SHOW_GLOBAL_SEARCH_MODAL: "TOGGLE_SHOW_GLOBAL_SEARCH_MODAL",
  RESTORE_RECENT_ENTITIES_REQUEST: "RESTORE_RECENT_ENTITIES_REQUEST",
  RESTORE_RECENT_ENTITIES_SUCCESS: "RESTORE_RECENT_ENTITIES_SUCCESS",
  SET_RECENT_ENTITIES: "SET_RECENT_ENTITIES",
  RESET_RECENT_ENTITIES: "RESET_RECENT_ENTITIES",
};

const FeatureFlagActionTypes = {
  FETCH_FEATURE_FLAGS_INIT: "FETCH_FEATURE_FLAGS_INIT",
  FETCH_FEATURE_FLAGS_SUCCESS: "FETCH_FEATURE_FLAGS_SUCCESS",
  FETCH_OVERRIDDEN_FEATURE_FLAGS: "FETCH_OVERRIDDEN_FEATURE_FLAGS",
  UPDATE_OVERRIDDEN_FEATURE_FLAGS: "UPDATE_OVERRIDDEN_FEATURE_FLAGS",
};

const FeatureFlagActionErrorTypes = {
  FETCH_FEATURE_FLAGS_ERROR: "FETCH_FEATURE_FLAGS_ERROR",
};

const SnippingModeActionTypes = {
  BIND_DATA_TO_WIDGET: "BIND_DATA_TO_WIDGET",
  BIND_DATA_ON_CANVAS: "BIND_DATA_ON_CANVAS",
  SET_SNIPING_MODE: "SET_SNIPING_MODE",
  RESET_SNIPING_MODE: "RESET_SNIPING_MODE",
};

const UserAuthActionTypes = {
  RESET_USER_PASSWORD_INIT: "RESET_USER_PASSWORD_INIT",
  RESET_USER_PASSWORD_SUCCESS: "RESET_USER_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_INIT: "FORGOT_PASSWORD_INIT",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  RESET_PASSWORD_VERIFY_TOKEN_SUCCESS: "RESET_PASSWORD_VERIFY_TOKEN_SUCCESS",
  RESET_PASSWORD_VERIFY_TOKEN_INIT: "RESET_PASSWORD_VERIFY_TOKEN_INIT",
  FETCH_USER_INIT: "FETCH_USER_INIT",
  FETCH_USER_SUCCESS: "FETCH_USER_SUCCESS",
  LOGOUT_USER_INIT: "LOGOUT_USER_INIT",
  LOGOUT_USER_SUCCESS: "LOGOUT_USER_SUCCESS",
  VERIFY_INVITE_INIT: "VERIFY_INVITE_INIT",
  VERIFY_INVITE_SUCCESS: "VERIFY_INVITE_SUCCESS",
  INVITED_USER_SIGNUP_INIT: "INVITED_USER_SIGNUP_INIT",
  INVITED_USER_SIGNUP_SUCCESS: "INVITED_USER_SIGNUP_SUCCESS",
  SAAS_GET_OAUTH_ACCESS_TOKEN: "SAAS_GET_OAUTH_ACCESS_TOKEN",
  GET_OAUTH_ACCESS_TOKEN: "GET_OAUTH_ACCESS_TOKEN",
  GET_OAUTH_ACCESS_TOKEN_SUCCESS: "GET_OAUTH_ACCESS_TOKEN_SUCCESS",
};
const UserAuthActionErrorTypes = {
  RESET_USER_PASSWORD_ERROR: "RESET_USER_PASSWORD_ERROR",
  FORGOT_PASSWORD_ERROR: "FORGOT_PASSWORD_ERROR",
  RESET_PASSWORD_VERIFY_TOKEN_ERROR: "RESET_PASSWORD_VERIFY_TOKEN_ERROR",
  FETCH_USER_ERROR: "FETCH_USER_ERROR",
  LOGOUT_USER_ERROR: "LOGOUT_USER_ERROR",
  VERIFY_INVITE_ERROR: "VERIFY_INVITE_ERROR",
  INVITED_USER_SIGNUP_ERROR: "INVITED_USER_SIGNUP_ERROR",
  GET_OAUTH_ACCESS_TOKEN_ERROR: "GET_OAUTH_ACCESS_TOKEN_ERROR",
};

const UserProfileActionTypes = {
  UPLOAD_PROFILE_PHOTO: "UPLOAD_PROFILE_PHOTO",
  REMOVE_PROFILE_PHOTO: "REMOVE_PROFILE_PHOTO",
  UPDATE_PHOTO_ID: "UPDATE_PHOTO_ID",
  UPDATE_USER_DETAILS_INIT: "UPDATE_USER_DETAILS_INIT",
  UPDATE_USER_DETAILS_SUCCESS: "UPDATE_USER_DETAILS_SUCCESS",
};

const UserProfileActionErrorTypes = {
  UPDATE_USER_DETAILS_ERROR: "UPDATE_USER_DETAILS_ERROR",
  USER_PROFILE_PICTURE_UPLOAD_FAILED: "USER_PROFILE_PICTURE_UPLOAD_FAILED",
  USER_IMAGE_INVALID_FILE_CONTENT: "USER_IMAGE_INVALID_FILE_CONTENT",
};

const OnboardingActionTypes = {
  PROCEED_TO_NEXT_TOUR_STEP: "PROCEED_TO_NEXT_TOUR_STEP",
  SET_ACTIVE_TOUR: "SET_ACTIVE_TOUR",
  RESET_ACTIVE_TOUR: "RESET_ACTIVE_TOUR",
  SET_ACTIVE_TOUR_INDEX: "SET_ACTIVE_TOUR_INDEX",
  TOGGLE_ONBOARDING_WIDGET_SELECTION: "TOGGLE_ONBOARDING_WIDGET_SELECTION",
  DISABLE_START_SIGNPOSTING: "DISABLE_START_SIGNPOSTING",
  REMOVE_FIRST_TIME_USER_ONBOARDING_APPLICATION_ID:
    "REMOVE_FIRST_TIME_USER_ONBOARDING_APPLICATION_ID",
  SET_FIRST_TIME_USER_ONBOARDING_APPLICATION_ID:
    "SET_FIRST_TIME_USER_ONBOARDING_APPLICATION_ID",
  SET_FIRST_TIME_USER_ONBOARDING_APPLICATION_IDS:
    "SET_FIRST_TIME_USER_ONBOARDING_APPLICATION_IDS",
  SET_FIRST_TIME_USER_ONBOARDING_COMPLETE:
    "SET_FIRST_TIME_USER_ONBOARDING_COMPLETE",
  SET_SHOW_FIRST_TIME_USER_ONBOARDING_MODAL:
    "SET_SHOW_FIRST_TIME_USER_ONBOARDING_MODAL",
  SET_FORCE_WIDGET_PANEL_OPEN: "SET_FORCE_WIDGET_PANEL_OPEN",
  END_FIRST_TIME_USER_ONBOARDING: "END_FIRST_TIME_USER_ONBOARDING",
  UNDO_END_FIRST_TIME_USER_ONBOARDING: "UNDO_END_FIRST_TIME_USER_ONBOARDING",
  SET_SIGNPOSTING_OVERLAY: "SET_SIGNPOSTING_OVERLAY",
  SIGNPOSTING_MARK_ALL_READ: "SIGNPOSTING_MARK_ALL_READ",
  SIGNPOSTING_SHOW_TOOLTIP: "SIGNPOSTING_SHOW_TOOLTIP",
  SHOW_ANONYMOUS_DATA_POPUP: "SHOW_ANONYMOUS_DATA_POPUP",
  FIRST_TIME_USER_ONBOARDING_INIT: "FIRST_TIME_USER_ONBOARDING_INIT",
  SET_USER_ROLE_USECASE: "SET_USER_ROLE_USECASE",
  SHOW_INFO_MESSAGE: "SHOW_INFO_MESSAGE",
  SET_CURRENT_APPLICATION_ID_FOR_CREATE_NEW_APP:
    "SET_CURRENT_APPLICATION_ID_FOR_CREATE_NEW_APP",
  RESET_CURRENT_APPLICATION_ID_FOR_CREATE_NEW_APP:
    "RESET_CURRENT_APPLICATION_ID_FOR_CREATE_NEW_APP",
  SET_CURRENT_PLUGIN_ID_FOR_CREATE_NEW_APP:
    "SET_CURRENT_PLUGIN_ID_FOR_CREATE_NEW_APP",
  RESET_CURRENT_PLUGIN_ID_FOR_CREATE_NEW_APP:
    "RESET_CURRENT_PLUGIN_ID_FOR_CREATE_NEW_APP",
};

const IDEActionTypes = {
  RESET_EDITOR_REQUEST: "RESET_EDITOR_REQUEST",
  RESET_EDITOR_SUCCESS: "RESET_EDITOR_SUCCESS",
  INITIALIZE_CURRENT_PAGE: "INITIALIZE_CURRENT_PAGE",
  INITIALIZE_EDITOR: "INITIALIZE_EDITOR",
  INITIALIZE_EDITOR_SUCCESS: "INITIALIZE_EDITOR_SUCCESS",
  INITIALIZE_PAGE_VIEWER: "INITIALIZE_PAGE_VIEWER",
  INITIALIZE_PAGE_VIEWER_SUCCESS: "INITIALIZE_PAGE_VIEWER_SUCCESS",
  SET_EXPLORER_PINNED: "SET_EXPLORER_PINNED",
  SET_EXPLORER_ACTIVE: "SET_EXPLORER_ACTIVE",
  SET_PREVIEW_MODE: "SET_PREVIEW_MODE",
  SET_PREVIEW_MODE_INIT: "SET_PREVIEW_MODE_INIT",
  ENTITY_UPDATE_STARTED: "ENTITY_UPDATE_STARTED",
  ENTITY_UPDATE_SUCCESS: "ENTITY_UPDATE_SUCCESS",
  SET_FOCUS_HISTORY: "SET_FOCUS_HISTORY",
  REMOVE_FOCUS_HISTORY: "REMOVE_FOCUS_HISTORY",
  SET_FOCUSABLE_PROPERTY_FIELD: "SET_FOCUSABLE_PROPERTY_FIELD",
  ROUTE_CHANGED: "ROUTE_CHANGED",
  SET_PLUGIN_ACTION_EDITOR_FORM_SELECTED_TAB:
    "SET_PLUGIN_ACTION_EDITOR_FORM_SELECTED_TAB",
  SET_API_PANE_CONFIG_SELECTED_TAB: "SET_API_PANE_CONFIG_SELECTED_TAB",
  SET_EDITOR_FIELD_FOCUS: "SET_EDITOR_FIELD_FOCUS",
  SET_FOCUSABLE_INPUT_FIELD: "SET_FOCUSABLE_INPUT_FIELD",
  SET_CODE_EDITOR_CURSOR: "SET_CODE_EDITOR_CURSOR",
  SET_CODE_EDITOR_CURSOR_HISTORY: "SET_CODE_EDITOR_CURSOR_HISTORY",
  SET_EVAL_POPUP_STATE: "SET_EVAL_POPUP_STATE",
  APPEND_SELECTED_WIDGET_TO_URL: "APPEND_SELECTED_WIDGET_TO_URL",
  SET_ALL_PROPERTY_SECTION_STATE: "SET_ALL_PROPERTY_SECTION_STATE",
  SET_PROPERTY_SECTION_STATE: "SET_PROPERTY_SECTION_STATE",
  SET_SELECTED_PROPERTY_TAB_INDEX: "SET_SELECTED_PROPERTY_TAB_INDEX",
  SET_QUERY_PANE_CONFIG_SELECTED_TAB: "SET_QUERY_PANE_CONFIG_SELECTED_TAB",
  SET_JS_PANE_CONFIG_SELECTED_TAB: "SET_JS_PANE_CONFIG_SELECTED_TAB",
  SET_SELECTED_PANEL_PROPERTY: "SET_SELECTED_PANEL_PROPERTY",
  UNSET_SELECTED_PANEL_PROPERTY: "UNSET_SELECTED_PANEL_PROPERTY",
  SET_SELECTED_PANELS: "SET_SELECTED_PANELS",
  SET_PANEL_SELECTED_PROPERTY_TAB_INDEX:
    "SET_PANEL_SELECTED_PROPERTY_TAB_INDEX",
  SET_PANEL_PROPERTY_SECTION_STATE: "SET_PANEL_PROPERTY_SECTION_STATE",
  SET_WIDGET_SELECTED_PROPERTY_TAB_INDEX:
    "SET_WIDGET_SELECTED_PROPERTY_TAB_INDEX",
  SET_WIDGET_PROPERTY_SECTION_STATE: "SET_WIDGET_PROPERTY_SECTION_STATE",
  SET_PANEL_PROPERTIES_STATE: "SET_PANEL_PROPERTIES_STATE",
  SET_ENTITY_COLLAPSIBLE_STATE: "SET_ENTITY_COLLAPSIBLE_STATE",
  SET_ALL_ENTITY_COLLAPSIBLE_STATE: "SET_ALL_ENTITY_COLLAPSIBLE_STATE",
  SET_ALL_SUB_ENTITY_COLLAPSIBLE_STATE: "SET_ALL_SUB_ENTITY_COLLAPSIBLE_STATE",
  SET_EXPLORER_SWITCH_INDEX: "SET_EXPLORER_SWITCH_INDEX",
  WIDGET_INIT_SUCCESS: "WIDGET_INIT_SUCCESS",
  SETUP_PAGE_INIT: "SETUP_PAGE_INIT",
  SETUP_PAGE_SUCCESS: "SETUP_PAGE_SUCCESS",
  SETUP_PUBLISHED_PAGE_INIT: "SETUP_PUBLISHED_PAGE_INIT",
  SETUP_PUBLISHED_PAGE_SUCCESS: "SETUP_PUBLISHED_PAGE_SUCCESS",
  SET_IDE_EDITOR_VIEW_MODE: "SET_IDE_EDITOR_VIEW_MODE",
  RESTORE_IDE_EDITOR_VIEW_MODE: "RESTORE_IDE_EDITOR_VIEW_MODE",
  SET_IDE_TABS: "SET_IDE_TABS",
  SET_IDE_JS_TABS: "SET_IDE_JS_TABS",
  SET_IDE_QUERIES_TABS: "SET_IDE_QUERIES_TABS",
  SET_SHOW_QUERY_CREATE_NEW_MODAL: "SET_SHOW_QUERY_CREATE_NEW_MODAL",
  SET_WIDGET_SELECTION_BLOCK: "SET_WIDGET_SELECTION_BLOCK",
  ALT_FOCUS_WIDGET: "ALT_FOCUS_WIDGET",
  CREATE_NEW_JS_FROM_ACTION_CREATOR: "CREATE_NEW_JS_FROM_ACTION_CREATOR",
  CREATE_NEW_QUERY_FROM_ACTION_CREATOR: "CREATE_NEW_QUERY_FROM_ACTION_CREATOR",
  CLOSE_JS_ACTION_TAB: "CLOSE_JS_ACTION_TAB",
  CLOSE_JS_ACTION_TAB_SUCCESS: "CLOSE_JS_ACTION_TAB_SUCCESS",
  CLOSE_QUERY_ACTION_TAB: "CLOSE_QUERY_ACTION_TAB",
  CLOSE_QUERY_ACTION_TAB_SUCCESS: "CLOSE_QUERY_ACTION_TAB_SUCCESS",
  SET_IS_LIST_VIEW_ACTIVE: "SET_IS_LIST_VIEW_ACTIVE",
  OPEN_PLUGIN_ACTION_SETTINGS: "OPEN_PLUGIN_ACTION_SETTINGS",
  SET_RENAME_ENTITY: "SET_RENAME_ENTITY",
};

const IDEActionErrorTypes = {
  SETUP_PAGE_ERROR: "SETUP_PAGE_ERROR",
  SETUP_PUBLISHED_PAGE_ERROR: "SETUP_PUBLISHED_PAGE_ERROR",
};

const ErrorManagementActionTypes = {
  REPORT_ERROR: "REPORT_ERROR",
  FLUSH_ERRORS: "FLUSH_ERRORS",
  FLUSH_AND_REDIRECT: "FLUSH_AND_REDIRECT",
  SAFE_CRASH_APPSMITH: "SAFE_CRASH_APPSMITH",
  SAFE_CRASH_APPSMITH_REQUEST: "SAFE_CRASH_APPSMITH_REQUEST",
};

const WidgetReflowActionTypes = {
  STOP_REFLOW: "STOP_REFLOW",
  REFLOW_MOVE: "REFLOW_MOVE",
};

const WidgetCanvasActionTypes = {
  ...WidgetReflowActionTypes,
  INIT_CANVAS_LAYOUT: "INIT_CANVAS_LAYOUT",
  START_CANVAS_SELECTION_FROM_EDITOR: "START_CANVAS_SELECTION_FROM_EDITOR",
  STOP_CANVAS_SELECTION_FROM_EDITOR: "STOP_CANVAS_SELECTION_FROM_EDITOR",
  START_CANVAS_SELECTION: "START_CANVAS_SELECTION",
  STOP_CANVAS_SELECTION: "STOP_CANVAS_SELECTION",
  WIDGET_ADD_CHILD: "WIDGET_ADD_CHILD",
  WIDGET_CHILD_ADDED: "WIDGET_CHILD_ADDED",
  WIDGET_REMOVE_CHILD: "WIDGET_REMOVE_CHILD",
  WIDGETS_MOVE: "WIDGETS_MOVE",
  WIDGETS_ADD_CHILD_AND_MOVE: "WIDGETS_ADD_CHILD_AND_MOVE",
  WIDGET_RESIZE: "WIDGET_RESIZE",
  WIDGET_DELETE: "WIDGET_DELETE",
  WIDGET_BULK_DELETE: "WIDGET_BULK_DELETE",
  WIDGET_SINGLE_DELETE: "WIDGET_SINGLE_DELETE",
  UPDATE_CANVAS_LAYOUT: "UPDATE_CANVAS_LAYOUT",
  DISABLE_WIDGET_DRAG: "DISABLE_WIDGET_DRAG",
  SELECT_WIDGET_INIT: "SELECT_WIDGET_INIT",
  FOCUS_WIDGET: "FOCUS_WIDGET",
  SET_SELECTED_WIDGETS: "SET_SELECTED_WIDGETS",
  SET_LAST_SELECTED_WIDGET: "SET_LAST_SELECTED_WIDGET",
  SET_WIDGET_DRAGGING: "SET_WIDGET_DRAGGING",
  SET_DRAGGING_CANVAS: "SET_DRAGGING_CANVAS",
  SET_NEW_WIDGET_DRAGGING: "SET_NEW_WIDGET_DRAGGING",
  SET_WIDGET_RESIZING: "SET_WIDGET_RESIZING",
  SET_AUTO_CANVAS_RESIZING: "SET_AUTO_CANVAS_RESIZING",
  ADD_SUGGESTED_WIDGET: "ADD_SUGGESTED_WIDGET",
  MODIFY_META_WIDGETS: "MODIFY_META_WIDGETS",
  MODIFY_META_WIDGETS_WITHOUT_EVAL: "MODIFY_META_WIDGETS_WITHOUT_EVAL",
  DELETE_META_WIDGETS: "DELETE_META_WIDGETS",
  UPDATE_META_WIDGET_PROPERTY_INIT: "UPDATE_META_WIDGET_PROPERTY_INIT",
  UPDATE_META_WIDGET_PROPERTY: "UPDATE_META_WIDGET_PROPERTY",
  SHOW_MODAL: "SHOW_MODAL",
  SHOW_MODAL_BY_NAME: "SHOW_MODAL_BY_NAME",
  CLOSE_MODAL: "CLOSE_MODAL",
  CREATE_MODAL_INIT: "CREATE_MODAL_INIT",
  CREATE_MODAL_SUCCESS: "CREATE_MODAL_SUCCESS",
  UPDATE_CANVAS_SIZE: "UPDATE_CANVAS_SIZE",
  POPULATE_PAGEDSLS_INIT: "POPULATE_PAGEDSLS_INIT",
  POPULATE_PAGEDSLS_SUCCESS: "POPULATE_PAGEDSLS_SUCCESS",
  FETCH_PAGE_DSLS_SUCCESS: "FETCH_PAGE_DSLS_SUCCESS",
  FETCH_PAGE_DSL_SUCCESS: "FETCH_PAGE_DSL_SUCCESS",
  COPY_SELECTED_WIDGET_SUCCESS: "COPY_SELECTED_WIDGET_SUCCESS",
  COPY_SELECTED_WIDGET_INIT: "COPY_SELECTED_WIDGET_INIT",
  ADD_CANVAS_WIDGET: "ADD_CANVAS_WIDGET",
  VERIFY_LAYOUT_SYSTEM_AND_PASTE_WIDGETS:
    "VERIFY_LAYOUT_SYSTEM_AND_PASTE_WIDGETS",
  PASTE_COPIED_WIDGET_INIT: "PASTE_COPIED_WIDGET_INIT",
  PASTE_COPIED_WIDGET_SUCCESS: "PASTE_COPIED_WIDGET_SUCCESS",
  CUT_SELECTED_WIDGET: "CUT_SELECTED_WIDGET",
  UPDATE_CANVAS_STRUCTURE: "UPDATE_CANVAS_STRUCTURE",
  SET_SELECTED_WIDGET_ANCESTRY: "SET_SELECTED_WIDGET_ANCESTRY",
  SET_ENTITY_EXPLORER_WIDGET_ANCESTRY: "SET_ENTITY_EXPLORER_WIDGET_ANCESTRY",
  SET_WIDGET_LOADING: "SET_WIDGET_LOADING",
  SELECT_WIDGETS_IN_AREA: "SELECT_WIDGETS_IN_AREA",
  GROUP_WIDGETS_INIT: "GROUP_WIDGETS_INIT",
  WIDGET_ADD_NEW_TAB_CHILD: "WIDGET_ADD_NEW_TAB_CHILD",
  WIDGET_DELETE_TAB_CHILD: "WIDGET_DELETE_TAB_CHILD",
  RECORD_RECENTLY_ADDED_WIDGET: "RECORD_RECENTLY_ADDED_WIDGET",
  REMOVE_FROM_RECENTLY_ADDED_WIDGET: "REMOVE_FROM_RECENTLY_ADDED_WIDGET",
  SET_AUTO_HEIGHT_LAYOUT_TREE: "SET_AUTO_HEIGHT_LAYOUT_TREE",
  UPDATE_MULTIPLE_WIDGET_PROPERTIES: "UPDATE_MULTIPLE_WIDGET_PROPERTIES",
  UPDATE_MULTIPLE_META_WIDGET_PROPERTIES:
    "UPDATE_MULTIPLE_META_WIDGET_PROPERTIES",
  SET_CANVAS_LEVELS_MAP: "SET_CANVAS_LEVELS_MAP",
  GENERATE_AUTO_HEIGHT_LAYOUT_TREE: "GENERATE_AUTO_HEIGHT_LAYOUT_TREE",
  CHECK_CONTAINERS_FOR_AUTO_HEIGHT: "CHECK_CONTAINERS_FOR_AUTO_HEIGHT",
  UPDATE_WIDGET_AUTO_HEIGHT: "UPDATE_WIDGET_AUTO_HEIGHT",
  SET_AUTO_HEIGHT_WITH_LIMITS_CHANGING: "SET_AUTO_HEIGHT_WITH_LIMITS_CHANGING",
  PROCESS_AUTO_HEIGHT_UPDATES: "PROCESS_AUTO_HEIGHT_UPDATES",
  DIRECT_DOM_UPDATE_AUTO_HEIGHT: "DIRECT_DOM_UPDATE_AUTO_HEIGHT",
  AUTOLAYOUT_REORDER_WIDGETS: "AUTOLAYOUT_REORDER_WIDGETS",
  AUTOLAYOUT_ADD_NEW_WIDGETS: "AUTOLAYOUT_ADD_NEW_WIDGETS",
  RECALCULATE_COLUMNS: "RECALCULATE_COLUMNS",
  UPDATE_LAYOUT_SYSTEM_TYPE: "UPDATE_LAYOUT_SYSTEM_TYPE",
  SET_LAYOUT_CONVERSION_STATE: "SET_LAYOUT_CONVERSION_STATE",
  START_CONVERSION_FLOW: "START_CONVERSION_FLOW",
  STOP_CONVERSION_FLOW: "STOP_CONVERSION_FLOW",
  UPDATE_SNAPSHOT_DETAILS: "UPDATE_SNAPSHOT_DETAILS",
  CONVERT_AUTO_TO_FIXED: "CONVERT_AUTO_TO_FIXED",
  CONVERT_FIXED_TO_AUTO: "CONVERT_FIXED_TO_AUTO",
  REFRESH_THE_APP: "REFRESH_THE_APP",
  LOG_LAYOUT_CONVERSION_ERROR: "LOG_LAYOUT_CONVERSION_ERROR",
  RESTORE_SNAPSHOT: "RESTORE_SNAPSHOT",
  FETCH_LAYOUT_SNAPSHOT_DETAILS: "FETCH_LAYOUT_SNAPSHOT_DETAILS",
  DELETE_SNAPSHOT: "DELETE_SNAPSHOT",
  UPDATE_WIDGET_DIMENSIONS: "UPDATE_WIDGET_DIMENSIONS",
  PROCESS_AUTO_LAYOUT_DIMENSION_UPDATES:
    "PROCESS_AUTO_LAYOUT_DIMENSION_UPDATES",
  UPDATE_POSITIONS_ON_TAB_CHANGE: "UPDATE_POSITIONS_ON_TAB_CHANGE",
};

const WidgetCanvasActionErrorTypes = {
  CREATE_MODAL_ERROR: "CREATE_MODAL_ERROR",
  POPULATE_PAGEDSLS_ERROR: "POPULATE_PAGEDSLS_ERROR",
  FETCH_PAGE_DSL_ERROR: "FETCH_PAGE_DSL_ERROR",
  COPY_SELECTED_WIDGET_ERROR: "COPY_SELECTED_WIDGET_ERROR",
  PASTE_COPIED_WIDGET_ERROR: "PASTE_COPIED_WIDGET_ERROR",
};

const PageActionTypes = {
  FETCH_PAGE_INIT: "FETCH_PAGE_INIT",
  FETCH_PAGE_SUCCESS: "FETCH_PAGE_SUCCESS",
  SAVE_PAGE_INIT: "SAVE_PAGE_INIT",
  SAVE_PAGE_SUCCESS: "SAVE_PAGE_SUCCESS",
  UPDATE_LAYOUT: "UPDATE_LAYOUT",
  CREATE_PAGE_INIT: "CREATE_PAGE_INIT",
  CREATE_PAGE_SUCCESS: "CREATE_PAGE_SUCCESS",
  FETCH_PAGE_LIST_INIT: "FETCH_PAGE_LIST_INIT",
  FETCH_PAGE_LIST_SUCCESS: "FETCH_PAGE_LIST_SUCCESS",
  UPDATE_PAGE_LIST: "UPDATE_PAGE_LIST",
  CREATE_NEW_PAGE_FROM_ENTITIES: "CREATE_NEW_PAGE_FROM_ENTITIES",
  UPDATE_PAGE_INIT: "UPDATE_PAGE_INIT",
  UPDATE_PAGE_SUCCESS: "UPDATE_PAGE_SUCCESS",
  DELETE_PAGE_INIT: "DELETE_PAGE_INIT",
  DELETE_PAGE_SUCCESS: "DELETE_PAGE_SUCCESS",
  CLONE_PAGE_INIT: "CLONE_PAGE_INIT",
  CLONE_PAGE_SUCCESS: "CLONE_PAGE_SUCCESS",
  SET_DEFAULT_APPLICATION_PAGE_INIT: "SET_DEFAULT_APPLICATION_PAGE_INIT",
  SET_DEFAULT_APPLICATION_PAGE_SUCCESS: "SET_DEFAULT_APPLICATION_PAGE_SUCCESS",
  SWITCH_CURRENT_PAGE_ID: "SWITCH_CURRENT_PAGE_ID",
  UNDO_REDO_OPERATION: "UNDO_REDO_OPERATION",
  SET_PAGE_ORDER_INIT: "SET_PAGE_ORDER_INIT",
  SET_PAGE_ORDER_SUCCESS: "SET_PAGE_ORDER_SUCCESS",
  RESET_PAGE_LIST: "RESET_PAGE_LIST",
  SET_ONLOAD_ACTION_EXECUTED: "SET_ONLOAD_ACTION_EXECUTED",
  EXECUTE_REACTIVE_QUERIES: "EXECUTE_REACTIVE_QUERIES",
};

const PageActionErrorTypes = {
  FETCH_PAGE_ERROR: "FETCH_PAGE_ERROR",
  SAVE_PAGE_ERROR: "SAVE_PAGE_ERROR",
  CREATE_PAGE_ERROR: "CREATE_PAGE_ERROR",
  FETCH_PAGE_LIST_ERROR: "FETCH_PAGE_LIST_ERROR",
  UPDATE_PAGE_ERROR: "UPDATE_PAGE_ERROR",
  DELETE_PAGE_ERROR: "DELETE_PAGE_ERROR",
  CLONE_PAGE_ERROR: "CLONE_PAGE_ERROR",
  SET_PAGE_ORDER_ERROR: "SET_PAGE_ORDER_ERROR",
};

const ApplicationActionTypes = {
  UPDATE_APPLICATION: "UPDATE_APPLICATION",
  UPDATE_APP_LAYOUT: "UPDATE_APP_LAYOUT",
  UPDATE_APPLICATION_SUCCESS: "UPDATE_APPLICATION_SUCCESS",
  FETCH_APPLICATION_INIT: "FETCH_APPLICATION_INIT",
  FETCH_APPLICATION_SUCCESS: "FETCH_APPLICATION_SUCCESS",
  CREATE_APPLICATION_INIT: "CREATE_APPLICATION_INIT",
  CREATE_APPLICATION_SUCCESS: "CREATE_APPLICATION_SUCCESS",
  SET_LAST_UPDATED_TIME: "SET_LAST_UPDATED_TIME",
  SEARCH_APPLICATIONS: "SEARCH_APPLICATIONS",
  DELETE_APPLICATION_INIT: "DELETE_APPLICATION_INIT",
  DELETE_APPLICATION_SUCCESS: "DELETE_APPLICATION_SUCCESS",
  CURRENT_APPLICATION_NAME_UPDATE: "CURRENT_APPLICATION_NAME_UPDATE",
  CURRENT_APPLICATION_COMMUNITY_TEMPLATE_STATUS_UPDATE:
    "CURRENT_APPLICATION_COMMUNITY_TEMPLATE_STATUS_UPDATE",
  CURRENT_APPLICATION_LAYOUT_UPDATE: "CURRENT_APPLICATION_LAYOUT_UPDATE",
  CURRENT_APPLICATION_ICON_UPDATE: "CURRENT_APPLICATION_ICON_UPDATE",
  CURRENT_APPLICATION_EMBED_SETTING_UPDATE:
    "CURRENT_APPLICATION_EMBED_SETTING_UPDATE",
  UPDATE_NAVIGATION_SETTING: "UPDATE_NAVIGATION_SETTING",
  CURRENT_APPLICATION_FORKING_ENABLED_UPDATE:
    "CURRENT_APPLICATION_FORKING_ENABLED_UPDATE",
  FORK_APPLICATION_INIT: "FORK_APPLICATION_INIT",
  FORK_APPLICATION_SUCCESS: "FORK_APPLICATION_SUCCESS",
  RESET_CURRENT_APPLICATION: "RESET_CURRENT_APPLICATION",
};

const ApplicationActionErrorTypes = {
  UPDATE_APPLICATION_ERROR: "UPDATE_APPLICATION_ERROR",
  UPDATE_APP_LAYOUT_ERROR: "UPDATE_APP_LAYOUT_ERROR",
  FETCH_APPLICATION_ERROR: "FETCH_APPLICATION_ERROR",
  CREATE_APPLICATION_ERROR: "CREATE_APPLICATION_ERROR",
  DELETE_APPLICATION_ERROR: "DELETE_APPLICATION_ERROR",
  SET_DEFAULT_APPLICATION_PAGE_ERROR: "SET_DEFAULT_APPLICATION_PAGE_ERROR",
  FORK_APPLICATION_ERROR: "FORK_APPLICATION_ERROR",
};

const IDEDebuggerActionTypes = {
  DEBUGGER_LOG: "DEBUGGER_LOG",
  DEBUGGER_LOG_INIT: "DEBUGGER_LOG_INIT",
  DEBUGGER_ERROR_ANALYTICS: "DEBUGGER_ERROR_ANALYTICS",
  DEBUGGER_ADD_ERROR_LOGS: "DEBUGGER_ADD_ERROR_LOGS",
  DEBUGGER_DELETE_ERROR_LOG: "DEBUGGER_DELETE_ERROR_LOG",
  DEBUGGER_ADD_ERROR_LOG_INIT: "DEBUGGER_ADD_ERROR_LOG_INIT",
  DEBUGGER_DELETE_ERROR_LOG_INIT: "DEBUGGER_DELETE_ERROR_LOG_INIT",
  SET_DEBUGGER_CONTEXT: "SET_DEBUGGER_CONTEXT",
  CLEAR_DEBUGGER_LOGS: "CLEAR_DEBUGGER_LOGS",
  SHOW_DEBUGGER: "SHOW_DEBUGGER",
  HIDE_DEBUGGER_ERRORS: "HIDE_DEBUGGER_ERRORS",
  SET_CURRENT_DEBUGGER_TAB: "SET_CURRENT_DEBUGGER_TAB",
  SET_DEBUGGER_SELECTED_TAB: "SET_DEBUGGER_SELECTED_TAB",
  SET_DEBUGGER_SELECTED_FILTER: "SET_DEBUGGER_SELECTED_FILTER",
  SET_RESPONSE_PANE_HEIGHT: "SET_RESPONSE_PANE_HEIGHT",
  SET_ERROR_COUNT: "SET_ERROR_COUNT",
  SET_RESPONSE_PANE_SCROLL_POSITION: "SET_RESPONSE_PANE_SCROLL_POSITION",
  TOGGLE_EXPAND_ERROR_LOG_ITEM: "TOGGLE_EXPAND_ERROR_LOG_ITEM",
  NAVIGATE_TO_ENTITY: "NAVIGATE_TO_ENTITY",
  SET_PLUGIN_ACTION_EDITOR_DEBUGGER_STATE:
    "SET_PLUGIN_ACTION_EDITOR_DEBUGGER_STATE",
  SET_QUERY_PANE_DEBUGGER_STATE: "SET_QUERY_PANE_DEBUGGER_STATE",
  SET_API_PANE_DEBUGGER_STATE: "SET_API_PANE_DEBUGGER_STATE",
  SET_JS_PANE_DEBUGGER_STATE: "SET_JS_PANE_DEBUGGER_STATE",
  SET_CANVAS_DEBUGGER_STATE: "SET_CANVAS_DEBUGGER_STATE",
  SHOW_DEBUGGER_LOGS: "SHOW_DEBUGGER_LOGS",
  SET_DEBUGGER_STATE_INSPECTOR_SELECTED_ITEM:
    "SET_DEBUGGER_STATE_INSPECTOR_SELECTED_ITEM",
};

const ThemeActionTypes = {
  SET_THEME: "SET_THEME",
  SET_HEADER_META: "SET_HEADER_META",
  UPDATE_BETA_CARD_SHOWN: "UPDATE_BETA_CARD_SHOWN",
  CLOSE_BETA_CARD_SHOWN: "CLOSE_BETA_CARD_SHOWN",
};

const ActionExecutionTypes = {
  RUN_ACTION_SHORTCUT_REQUEST: "RUN_ACTION_SHORTCUT_REQUEST",
  RUN_ACTION_REQUEST: "RUN_ACTION_REQUEST",
  RUN_ACTION_CANCELLED: "RUN_ACTION_CANCELLED",
  RUN_ACTION_SUCCESS: "RUN_ACTION_SUCCESS",
  GENERATE_JS_FUNCTION_SCHEMA_REQUEST: "GENERATE_JS_FUNCTION_SCHEMA_REQUEST",
  GENERATE_JS_FUNCTION_SCHEMA_CANCELLED:
    "GENERATE_JS_FUNCTION_SCHEMA_CANCELLED",
  GENERATE_JS_FUNCTION_SCHEMA_SUCCESS: "GENERATE_JS_FUNCTION_SCHEMA_SUCCESS",
  GENERATE_PLUGIN_ACTION_SCHEMA_REQUEST:
    "GENERATE_PLUGIN_ACTION_SCHEMA_REQUEST",
  GENERATE_PLUGIN_ACTION_SCHEMA_CANCELLED:
    "GENERATE_PLUGIN_ACTION_SCHEMA_CANCELLED",
  GENERATE_PLUGIN_ACTION_SCHEMA_SUCCESS:
    "GENERATE_PLUGIN_ACTION_SCHEMA_SUCCESS",
  GENERATE_AI_AGENT_SCHEMA_REQUEST: "GENERATE_AI_AGENT_SCHEMA_REQUEST",
  GENERATE_AI_AGENT_SCHEMA_CANCELLED: "GENERATE_AI_AGENT_SCHEMA_CANCELLED",
  GENERATE_AI_AGENT_SCHEMA_SUCCESS: "GENERATE_AI_AGENT_SCHEMA_SUCCESS",
  CLEAR_ACTION_RESPONSE: "CLEAR_ACTION_RESPONSE",
  SHOW_ACTION_MODAL: "SHOW_ACTION_MODAL",
  CANCEL_ACTION_MODAL: "CANCEL_ACTION_MODAL",
  CONFIRM_ACTION_MODAL: "CONFIRM_ACTION_MODAL",
  EXECUTE_PAGE_LOAD_ACTIONS: "EXECUTE_PAGE_LOAD_ACTIONS",
  EXECUTE_PLUGIN_ACTION_REQUEST: "EXECUTE_PLUGIN_ACTION_REQUEST",
  EXECUTE_PLUGIN_ACTION_SUCCESS: "EXECUTE_PLUGIN_ACTION_SUCCESS",
  SET_ACTION_RESPONSE_DISPLAY_FORMAT: "SET_ACTION_RESPONSE_DISPLAY_FORMAT",
};

const ActionExecutionErrorTypes = {
  RUN_ACTION_ERROR: "RUN_ACTION_ERROR",
  GENERATE_JS_FUNCTION_SCHEMA_ERROR: "GENERATE_JS_FUNCTION_SCHEMA_ERROR",
  GENERATE_PLUGIN_ACTION_SCHEMA_ERROR: "GENERATE_PLUGIN_ACTION_SCHEMA_ERROR",
  GENERATE_AI_AGENT_SCHEMA_ERROR: "GENERATE_AI_AGENT_SCHEMA_ERROR",
  EXECUTE_PLUGIN_ACTION_ERROR: "EXECUTE_PLUGIN_ACTION_ERROR",
};

const PluginActionTypes = {
  PLUGIN_SOFT_REFRESH: "PLUGIN_SOFT_REFRESH",
  FETCH_PLUGINS_REQUEST: "FETCH_PLUGINS_REQUEST",
  FETCH_PLUGINS_SUCCESS: "FETCH_PLUGINS_SUCCESS",
  FETCH_PLUGIN_FORM_CONFIGS_REQUEST: "FETCH_PLUGIN_FORM_CONFIGS_REQUEST",
  FETCH_PLUGIN_FORM_CONFIGS_SUCCESS: "FETCH_PLUGIN_FORM_CONFIGS_SUCCESS",
  FETCH_PLUGIN_FORM_SUCCESS: "FETCH_PLUGIN_FORM_SUCCESS",
  GET_PLUGIN_FORM_CONFIG_INIT: "GET_PLUGIN_FORM_CONFIG_INIT",
  GET_DEFAULT_PLUGINS_REQUEST: "GET_DEFAULT_PLUGINS_REQUEST",
  GET_DEFAULT_PLUGINS_SUCCESS: "GET_DEFAULT_PLUGINS_SUCCESS",
  GET_UPCOMING_PLUGINS_REQUEST: "GET_UPCOMING_PLUGINS_REQUEST",
  GET_UPCOMING_PLUGINS_SUCCESS: "GET_UPCOMING_PLUGINS_SUCCESS",
};
const PluginActionErrorTypes = {
  FETCH_PLUGINS_ERROR: "FETCH_PLUGINS_ERROR",
  FETCH_PLUGIN_FORM_CONFIGS_ERROR: "FETCH_PLUGIN_FORM_CONFIGS_ERROR",
  FETCH_PLUGIN_FORM_ERROR: "FETCH_PLUGIN_FORM_ERROR",
  GET_DEFAULT_PLUGINS_ERROR: "GET_DEFAULT_PLUGINS_ERROR",
  GET_UPCOMING_PLUGINS_ERROR: "GET_UPCOMING_PLUGINS_ERROR",
};

const UQIFormActionTypes = {
  SET_FORM_EVALUATION: "SET_FORM_EVALUATION",
  INIT_FORM_EVALUATION: "INIT_FORM_EVALUATION",
  RUN_FORM_EVALUATION: "RUN_FORM_EVALUATION",
  INIT_TRIGGER_VALUES: "INIT_TRIGGER_VALUES",
  FETCH_TRIGGER_VALUES_INIT: "FETCH_TRIGGER_VALUES_INIT",
  FETCH_TRIGGER_VALUES_SUCCESS: "FETCH_TRIGGER_VALUES_SUCCESS",
  SET_TRIGGER_VALUES_LOADING: "SET_TRIGGER_VALUES_LOADING",
  FORM_EVALUATION_EMPTY_BUFFER: "FORM_EVALUATION_EMPTY_BUFFER",
  FETCH_FORM_DYNAMIC_VAL_NEXT_PAGE_INIT:
    "FETCH_FORM_DYNAMIC_VAL_NEXT_PAGE_INIT",
  FETCH_FORM_DYNAMIC_VAL_NEXT_PAGE_SUCCESS:
    "FETCH_FORM_DYNAMIC_VAL_NEXT_PAGE_SUCCESS",
};

const ActionActionTypes = {
  ...ActionExecutionTypes,
  ...UQIFormActionTypes,
  API_PANE_CHANGE_API: "API_PANE_CHANGE_API",
  QUERY_PANE_CHANGE: "QUERY_PANE_CHANGE",
  EXECUTE_TRIGGER_REQUEST: "EXECUTE_TRIGGER_REQUEST",
  CREATE_ACTION_REQUEST: "CREATE_ACTION_REQUEST",
  CREATE_ACTION_INIT: "CREATE_ACTION_INIT",
  CREATE_ACTION_SUCCESS: "CREATE_ACTION_SUCCESS",
  FETCH_ACTIONS_INIT: "FETCH_ACTIONS_INIT",
  FETCH_ACTIONS_SUCCESS: "FETCH_ACTIONS_SUCCESS",
  UPDATE_ACTION_INIT: "UPDATE_ACTION_INIT",
  UPDATE_ACTION_SUCCESS: "UPDATE_ACTION_SUCCESS",
  DELETE_ACTION_INIT: "DELETE_ACTION_INIT",
  DELETE_ACTION_SUCCESS: "DELETE_ACTION_SUCCESS",
  MOVE_ACTION_INIT: "MOVE_ACTION_INIT",
  MOVE_ACTION_SUCCESS: "MOVE_ACTION_SUCCESS",
  COPY_ACTION_INIT: "COPY_ACTION_INIT",
  COPY_ACTION_SUCCESS: "COPY_ACTION_SUCCESS",
  FETCH_ACTIONS_FOR_PAGE_INIT: "FETCH_ACTIONS_FOR_PAGE_INIT",
  FETCH_ACTIONS_FOR_PAGE_SUCCESS: "FETCH_ACTIONS_FOR_PAGE_SUCCESS",
  CREATE_NEW_API_ACTION: "CREATE_NEW_API_ACTION",
  CREATE_NEW_QUERY_ACTION: "CREATE_NEW_QUERY_ACTION",
  SAVE_ACTION_NAME_INIT: "SAVE_ACTION_NAME_INIT",
  SAVE_ACTION_NAME_SUCCESS: "SAVE_ACTION_NAME_SUCCESS",
  SET_ACTION_PROPERTY: "SET_ACTION_PROPERTY",
  UPDATE_ACTION_PROPERTY: "UPDATE_ACTION_PROPERTY",
  SWITCH_DATASOURCE: "SWITCH_DATASOURCE",
  SET_ACTION_RUN_BEHAVIOR: "SET_ACTION_RUN_BEHAVIOR",
  UPDATE_ACTION_RUN_BEHAVIOR_INIT: "UPDATE_ACTION_RUN_BEHAVIOR_INIT",
  UPDATE_ACTION_RUN_BEHAVIOR_SUCCESS: "UPDATE_ACTION_RUN_BEHAVIOR_SUCCESS",
};

const ActionActionErrorTypes = {
  ...ActionExecutionErrorTypes,
  FETCH_ACTIONS_ERROR: "FETCH_ACTIONS_ERROR",
  CREATE_ACTION_ERROR: "CREATE_ACTION_ERROR",
  UPDATE_ACTION_ERROR: "UPDATE_ACTION_ERROR",
  DELETE_ACTION_ERROR: "DELETE_ACTION_ERROR",
  MOVE_ACTION_ERROR: "MOVE_ACTION_ERROR",
  COPY_ACTION_ERROR: "COPY_ACTION_ERROR",
  FETCH_ACTIONS_FOR_PAGE_ERROR: "FETCH_ACTIONS_FOR_PAGE_ERROR",
  SAVE_ACTION_NAME_ERROR: "SAVE_ACTION_NAME_ERROR",
  SAVE_API_NAME_ERROR: "SAVE_API_NAME_ERROR",
  UPDATE_ACTION_RUN_BEHAVIOR_ERROR: "UPDATE_ACTION_RUN_BEHAVIOR_ERROR",
};

const PropertyPanelActionTypes = {
  ...ActionSelectorReduxActionTypes,
  SHOW_PROPERTY_PANE: "SHOW_PROPERTY_PANE",
  HIDE_PROPERTY_PANE: "HIDE_PROPERTY_PANE",
  TOGGLE_PROPERTY_PANE_WIDGET_NAME_EDIT:
    "TOGGLE_PROPERTY_PANE_WIDGET_NAME_EDIT",
  SET_PROPERTY_PANE_WIDTH: "SET_PROPERTY_PANE_WIDTH",
};

const WidgetOperationsActionTypes = {
  UPDATE_WIDGET_PROPERTY_REQUEST: "UPDATE_WIDGET_PROPERTY_REQUEST",
  UPDATE_WIDGET_PROPERTY: "UPDATE_WIDGET_PROPERTY",
  UPDATE_WIDGET_DYNAMIC_PROPERTY: "UPDATE_WIDGET_DYNAMIC_PROPERTY",
  BATCH_UPDATE_WIDGET_PROPERTY: "BATCH_UPDATE_WIDGET_PROPERTY",
  BATCH_UPDATE_MULTIPLE_WIDGETS_PROPERTY:
    "BATCH_UPDATE_MULTIPLE_WIDGETS_PROPERTY",
  DELETE_WIDGET_PROPERTY: "DELETE_WIDGET_PROPERTY",
  UPDATE_WIDGET_NAME_INIT: "UPDATE_WIDGET_NAME_INIT",
  UPDATE_WIDGET_NAME_SUCCESS: "UPDATE_WIDGET_NAME_SUCCESS",
  SET_WIDGET_DYNAMIC_PROPERTY: "SET_WIDGET_DYNAMIC_PROPERTY",
  BATCH_SET_WIDGET_DYNAMIC_PROPERTY: "BATCH_SET_WIDGET_DYNAMIC_PROPERTY",
  RESET_APPLICATION_WIDGET_STATE_REQUEST:
    "RESET_APPLICATION_WIDGET_STATE_REQUEST",
};

const WidgetOperationActionErrorTypes = {
  WIDGET_OPERATION_ERROR: "WIDGET_OPERATION_ERROR",
  WIDGET_DELETE_ERROR: "WIDGET_DELETE_ERROR",
  WIDGET_MOVE_ERROR: "WIDGET_MOVE_ERROR",
  WIDGET_RESIZE_ERROR: "WIDGET_RESIZE_ERROR",
  WIDGET_REMOVE_CHILD_ERROR: "WIDGET_REMOVE_CHILD_ERROR",
  WIDGET_ADD_CHILD_ERROR: "WIDGET_ADD_CHILD_ERROR",
  WIDGET_SELECTION_ERROR: "WIDGET_SELECTION_ERROR",
  UPDATE_WIDGET_NAME_ERROR: "UPDATE_WIDGET_NAME_ERROR",
};

const DatasourceEditorActionTypes = {
  SET_DATASOURCE_EDITOR_MODE: "SET_DATASOURCE_EDITOR_MODE",
  SET_DATASOURCE_EDITOR_MODE_FLAG: "SET_DATASOURCE_EDITOR_MODE_FLAG",
  SET_DATASOURCE_COLLAPSIBLE_STATE: "SET_DATASOURCE_COLLAPSIBLE_STATE",
  SET_ALL_DATASOURCE_COLLAPSIBLE_STATE: "SET_ALL_DATASOURCE_COLLAPSIBLE_STATE",
  FETCH_DATASOURCES_INIT: "FETCH_DATASOURCES_INIT",
  FETCH_DATASOURCES_SUCCESS: "FETCH_DATASOURCES_SUCCESS",
  FETCH_MOCK_DATASOURCES_INIT: "FETCH_MOCK_DATASOURCES_INIT",
  FETCH_MOCK_DATASOURCES_SUCCESS: "FETCH_MOCK_DATASOURCES_SUCCESS",
  SOFT_REFRESH_DATASOURCE_STRUCTURE: "SOFT_REFRESH_DATASOURCE_STRUCTURE",
  ADD_MOCK_DATASOURCES_INIT: "ADD_MOCK_DATASOURCES_INIT",
  ADD_MOCK_DATASOURCES_SUCCESS: "ADD_MOCK_DATASOURCES_SUCCESS",
  SAVE_DATASOURCE_NAME: "SAVE_DATASOURCE_NAME",
  SAVE_DATASOURCE_NAME_SUCCESS: "SAVE_DATASOURCE_NAME_SUCCESS",
  UPDATE_DATASOURCE_NAME_SUCCESS: "UPDATE_DATASOURCE_NAME_SUCCESS",
  UPDATE_DATASOURCE_NAME: "UPDATE_DATASOURCE_NAME",
  CREATE_DATASOURCE_INIT: "CREATE_DATASOURCE_INIT",
  CREATE_DATASOURCE_SUCCESS: "CREATE_DATASOURCE_SUCCESS",
  CREATE_DATASOURCE_FROM_FORM_INIT: "CREATE_DATASOURCE_FROM_FORM_INIT",
  CREATE_DATASOURCE_FROM_FORM_TOGGLE_LOADING:
    "CREATE_DATASOURCE_FROM_FORM_TOGGLE_LOADING",
  CREATE_TEMP_DATASOURCE_FROM_FORM_SUCCESS:
    "CREATE_TEMP_DATASOURCE_FROM_FORM_SUCCESS",
  UPDATE_DATASOURCE_INIT: "UPDATE_DATASOURCE_INIT",
  UPDATE_DATASOURCE_SUCCESS: "UPDATE_DATASOURCE_SUCCESS",
  UPDATE_DATASOURCE_STORAGE_SUCCESS: "UPDATE_DATASOURCE_STORAGE_SUCCESS",
  CHANGE_DATASOURCE: "CHANGE_DATASOURCE",
  FETCH_DATASOURCE_STRUCTURE_INIT: "FETCH_DATASOURCE_STRUCTURE_INIT",
  ADD_AND_FETCH_MOCK_DATASOURCE_STRUCTURE_INIT:
    "ADD_AND_FETCH_MOCK_DATASOURCE_STRUCTURE_INIT",
  FETCH_DATASOURCE_STRUCTURE_SUCCESS: "FETCH_DATASOURCE_STRUCTURE_SUCCESS",
  REFRESH_DATASOURCE_STRUCTURE_INIT: "REFRESH_DATASOURCE_STRUCTURE_INIT",
  REFRESH_DATASOURCE_STRUCTURE_SUCCESS: "REFRESH_DATASOURCE_STRUCTURE_SUCCESS",
  EXPAND_DATASOURCE_ENTITY: "EXPAND_DATASOURCE_ENTITY",
  TEST_DATASOURCE_INIT: "TEST_DATASOURCE_INIT",
  TEST_DATASOURCE_SUCCESS: "TEST_DATASOURCE_SUCCESS",
  FETCH_UNCONFIGURED_DATASOURCE_LIST: "FETCH_UNCONFIGURED_DATASOURCE_LIST",
  DELETE_DATASOURCE_DRAFT: "DELETE_DATASOURCE_DRAFT",
  UPDATE_DATASOURCE_DRAFT: "UPDATE_DATASOURCE_DRAFT",
  REDIRECT_AUTHORIZATION_CODE: "REDIRECT_AUTHORIZATION_CODE",
  DELETE_DATASOURCE_INIT: "DELETE_DATASOURCE_INIT",
  DELETE_DATASOURCE_SUCCESS: "DELETE_DATASOURCE_SUCCESS",
  DELETE_DATASOURCE_CANCELLED: "DELETE_DATASOURCE_CANCELLED",
  STORE_AS_DATASOURCE_INIT: "STORE_AS_DATASOURCE_INIT",
  STORE_AS_DATASOURCE_UPDATE: "STORE_AS_DATASOURCE_UPDATE",
  STORE_AS_DATASOURCE_COMPLETE: "STORE_AS_DATASOURCE_COMPLETE",
  RESET_DATASOURCE_BANNER_MESSAGE: "RESET_DATASOURCE_BANNER_MESSAGE",
  UPDATE_DATASOURCE_REFS: "UPDATE_DATASOURCE_REFS",
  EXECUTE_DATASOURCE_QUERY_INIT: "EXECUTE_DATASOURCE_QUERY_INIT",
  EXECUTE_DATASOURCE_QUERY_SUCCESS: "EXECUTE_DATASOURCE_QUERY_SUCCESS",
  REMOVE_TEMP_DATASOURCE_SUCCESS: "REMOVE_TEMP_DATASOURCE_SUCCESS",
  SET_DATASOURCE_SAVE_ACTION_FLAG: "SET_DATASOURCE_SAVE_ACTION_FLAG",
  SET_DATASOURCE_SAVE_ACTION_FROM_POPUP_FLAG:
    "SET_DATASOURCE_SAVE_ACTION_FROM_POPUP_FLAG",
  SET_DATASOURCE_DEFAULT_KEY_VALUE_PAIR_SET:
    "SET_DATASOURCE_DEFAULT_KEY_VALUE_PAIR_SET",
  RESET_DATASOURCE_DEFAULT_KEY_VALUE_PAIR_SET:
    "RESET_DATASOURCE_DEFAULT_KEY_VALUE_PAIR_SET",
  INITIALIZE_DATASOURCE_FORM_WITH_DEFAULTS:
    "INITIALIZE_DATASOURCE_FORM_WITH_DEFAULTS",
  SET_GSHEET_TOKEN: "SET_GSHEET_TOKEN",
  FILE_PICKER_CALLBACK_ACTION: "FILE_PICKER_CALLBACK_ACTION",
  LOAD_FILE_PICKER_ACTION: "LOAD_FILE_PICKER_ACTION",
  UPDATE_DATASOURCE_AUTH_STATE: "UPDATE_DATASOURCE_AUTH_STATE",
  DATASOURCE_DISCARD_ACTION: "DATASOURCE_DISCARD_ACTION",
  SWITCH_ENVIRONMENT_SUCCESS: "SWITCH_ENVIRONMENT_SUCCESS",
  SET_DATASOURCE_PREVIEW_SELECTED_TABLE_NAME:
    "SET_DATASOURCE_PREVIEW_SELECTED_TABLE_NAME",
  FETCH_ENVIRONMENT_SUCCESS: "FETCH_ENVIRONMENT_SUCCESS",
};
const DatasourceEditorActionErrorTypes = {
  FETCH_DATASOURCES_ERROR: "FETCH_DATASOURCES_ERROR",
  FETCH_MOCK_DATASOURCES_ERROR: "FETCH_MOCK_DATASOURCES_ERROR",
  ADD_MOCK_DATASOURCES_ERROR: "ADD_MOCK_DATASOURCES_ERROR",
  UPDATE_DATASOURCE_ERROR: "UPDATE_DATASOURCE_ERROR",
  UPDATE_DATASOURCE_NAME_ERROR: "UPDATE_DATASOURCE_NAME_ERROR",
  CREATE_DATASOURCE_ERROR: "CREATE_DATASOURCE_ERROR",
  DELETE_DATASOURCE_ERROR: "DELETE_DATASOURCE_ERROR",
  FETCH_DATASOURCE_STRUCTURE_ERROR: "FETCH_DATASOURCE_STRUCTURE_ERROR",
  REFRESH_DATASOURCE_STRUCTURE_ERROR: "REFRESH_DATASOURCE_STRUCTURE_ERROR",
  TEST_DATASOURCE_ERROR: "TEST_DATASOURCE_ERROR",
  EXECUTE_DATASOURCE_QUERY_ERROR: "EXECUTE_DATASOURCE_QUERY_ERROR",
};

const BuildingBlocksActionTypes = {
  APPEND_ACTION_AFTER_BUILDING_BLOCK_DROP:
    "APPEND_ACTION_AFTER_BUILDING_BLOCK_DROP",
  DRAGGING_BUILDING_BLOCK_TO_CANVAS_INIT:
    "DRAGGING_BUILDING_BLOCK_TO_CANVAS_INIT",
  DRAGGING_BUILDING_BLOCK_TO_CANVAS_SUCCESS:
    "DRAGGING_BUILDING_BLOCK_TO_CANVAS_SUCCESS",
  SET_CURRENT_FORKING_BUILDING_BLOCK_NAME:
    "SET_CURRENT_FORKING_BUILDING_BLOCK_NAME",
};

const BuildingBlocksActionErrorTypes = {
  DRAGGING_BUILDING_BLOCK_TO_CANVAS_ERROR:
    "DRAGGING_BUILDING_BLOCK_TO_CANVAS_ERROR",
};

const ShareAppActionTypes = {
  CHANGE_APPVIEW_ACCESS_INIT: "CHANGE_APPVIEW_ACCESS_INIT",
  CHANGE_APPVIEW_ACCESS_SUCCESS: "CHANGE_APPVIEW_ACCESS_SUCCESS",
  INVITED_USERS_TO_WORKSPACE: "INVITED_USERS_TO_WORKSPACE",
};

const ShareAppActionErrorTypes = {
  CHANGE_APPVIEW_ACCESS_ERROR: "CHANGE_APPVIEW_ACCESS_ERROR",
};

const AppViewActionTypes = {
  ...ShareAppActionTypes,
  FETCH_PUBLISHED_PAGE_INIT: "FETCH_PUBLISHED_PAGE_INIT",
  FETCH_PUBLISHED_PAGE_SUCCESS: "FETCH_PUBLISHED_PAGE_SUCCESS",
  PUBLISH_APPLICATION_INIT: "PUBLISH_APPLICATION_INIT",
  PUBLISH_APPLICATION_SUCCESS: "PUBLISH_APPLICATION_SUCCESS",
  FETCH_ALL_PUBLISHED_PAGES: "FETCH_ALL_PUBLISHED_PAGES",
  FETCH_ACTIONS_VIEW_MODE_INIT: "FETCH_ACTIONS_VIEW_MODE_INIT",
  FETCH_ACTIONS_VIEW_MODE_SUCCESS: "FETCH_ACTIONS_VIEW_MODE_SUCCESS",
  FETCH_JS_ACTIONS_VIEW_MODE_INIT: "FETCH_JS_ACTIONS_VIEW_MODE_INIT",
  FETCH_JS_ACTIONS_VIEW_MODE_SUCCESS: "FETCH_JS_ACTIONS_VIEW_MODE_SUCCESS",
  SET_APP_VIEWER_HEADER_HEIGHT: "SET_APP_VIEWER_HEADER_HEIGHT",
  SET_APP_SIDEBAR_PINNED: "SET_APP_SIDEBAR_PINNED",
  FETCH_PUBLISHED_PAGE_RESOURCES_INIT: "FETCH_PUBLISHED_PAGE_RESOURCES_INIT",
  FETCH_PUBLISHED_PAGE_RESOURCES_SUCCESS:
    "FETCH_PUBLISHED_PAGE_RESOURCES_SUCCESS",
  PUBLISH_ANVIL_APPLICATION_INIT: "PUBLISH_ANVIL_APPLICATION_INIT",
  PUBLISH_ANVIL_APPLICATION_SUCCESS: "PUBLISH_ANVIL_APPLICATION_SUCCESS",
};

const AppViewActionErrorTypes = {
  ...ShareAppActionErrorTypes,
  FETCH_PUBLISHED_PAGE_ERROR: "FETCH_PUBLISHED_PAGE_ERROR",
  PUBLISH_APPLICATION_ERROR: "PUBLISH_APPLICATION_ERROR",
  FETCH_ACTIONS_VIEW_MODE_ERROR: "FETCH_ACTION_VIEW_MODE_ERROR",
  FETCH_JS_ACTIONS_VIEW_MODE_ERROR: "FETCH_JS_ACTIONS_VIEW_MODE_ERROR",
  FETCH_PUBLISHED_PAGE_RESOURCES_ERROR: "FETCH_PUBLISHED_PAGE_RESOURCES_ERROR",
  PUBLISH_ANVIL_APPLICATION_ERROR: "PUBLISH_ANVIL_APPLICATION_ERROR",
};

const WorkspaceActionTypes = {
  INVITE_USERS_TO_WORKSPACE_INIT: "INVITE_USERS_TO_WORKSPACE_INIT",
  FETCH_WORKSPACE_SUCCESS: "FETCH_WORKSPACE_SUCCESS",
  SAVE_WORKSPACE_INIT: "SAVE_WORKSPACE_INIT",
  SAVE_WORKSPACE_SUCCESS: "SAVE_WORKSPACE_SUCCESS",
  UPLOAD_WORKSPACE_LOGO: "UPLOAD_WORKSPACE_LOGO",
  REMOVE_WORKSPACE_LOGO: "REMOVE_WORKSPACE_LOGO",
  SET_CURRENT_WORKSPACE: "SET_CURRENT_WORKSPACE",
  SET_CURRENT_WORKSPACE_ID: "SET_CURRENT_WORKSPACE_ID",
  FETCH_CURRENT_WORKSPACE: "FETCH_CURRENT_WORKSPACE",
  CREATE_WORKSPACE_INIT: "CREATE_WORKSPACE_INIT",
  CREATE_WORKSPACE_SUCCESS: "CREATE_WORKSPACE_SUCCESS",
  ADD_USER_TO_WORKSPACE_INIT: "ADD_USER_TO_WORKSPACE_INIT",
  ADD_USER_TO_WORKSPACE_SUCCESS: "ADD_USER_TO_WORKSPACE_ERROR",
  FETCH_ALL_APPLICATIONS_OF_WORKSPACE_INIT:
    "FETCH_ALL_APPLICATIONS_OF_WORKSPACE_INIT",
  FETCH_ALL_APPLICATIONS_OF_WORKSPACE_SUCCESS:
    "FETCH_ALL_APPLICATIONS_OF_WORKSPACE_SUCCESS",
  GET_ALL_USERS_OF_WORKSPACE_SUCCESS: "GET_ALL_USERS_OF_WORKSPACE_SUCCESS",
  FETCH_ALL_WORKSPACES_INIT: "FETCH_ALL_WORKSPACES_INIT",
  FETCH_ALL_WORKSPACES_SUCCESS: "FETCH_ALL_WORKSPACES_SUCCESS",
  FETCH_USER_DETAILS_SUCCESS: "FETCH_USER_DETAILS_SUCCESS",
  FETCH_ALL_USERS_SUCCESS: "FETCH_ALL_USERS_SUCCESS",
  FETCH_ALL_USERS_INIT: "FETCH_ALL_USERS_INIT",
  FETCH_ALL_ROLES_SUCCESS: "FETCH_ALL_ROLES_SUCCESS",
  FETCH_ALL_ROLES_INIT: "FETCH_ALL_ROLES_INIT",
  DELETE_WORKSPACE_USER_INIT: "DELETE_WORKSPACE_USER_INIT",
  DELETE_WORKSPACE_USER_SUCCESS: "DELETE_WORKSPACE_USER_SUCCESS",
  LEAVE_WORKSPACE_INIT: "LEAVE_WORKSPACE_INIT",
  CHANGE_WORKSPACE_USER_ROLE_INIT: "CHANGE_WORKSPACE_USER_ROLE_INIT",
  CHANGE_WORKSPACE_USER_ROLE_SUCCESS: "CHANGE_WORKSPACE_USER_ROLE_SUCCESS",
  RESET_CURRENT_WORKSPACE: "RESET_CURRENT_WORKSPACE",
  DELETE_WORKSPACE_INIT: "DELETE_WORKSPACE_INIT",
  DELETE_WORKSPACE_SUCCESS: "DELETE_WORKSPACE_SUCCESS",
  SEARCH_WORKSPACE_ENTITIES_INIT: "SEARCH_WORKSPACE_ENTITIES_INIT",
  SEARCH_WORKSPACE_ENTITIES_SUCCESS: "SEARCH_WORKSPACE_ENTITIES_SUCCESS",
  UPDATE_THEME_SETTING: "UPDATE_THEME_SETTING",
  SEARCH_WORKSPACE_ENTITIES_RESET: "SEARCH_WORKSPACE_ENTITIES_RESET",
  FETCH_ENTITIES_OF_WORKSPACE_INIT: "FETCH_ENTITIES_OF_WORKSPACE_INIT",
  START_CONSOLIDATED_PAGE_LOAD: "START_CONSOLIDATED_PAGE_LOAD",
  END_CONSOLIDATED_PAGE_LOAD: "END_CONSOLIDATED_PAGE_LOAD",
};
const WorkspaceActionErrorTypes = {
  FETCH_USER_DETAILS_ERROR: "FETCH_USER_DETAILS_ERROR",
  CHANGE_WORKSPACE_USER_ROLE_ERROR: "CHANGE_WORKSPACE_USER_ROLE_ERROR",
  SAVE_WORKSPACE_ERROR: "SAVE_WORKSPACE_ERROR",
  FETCH_WORKSPACE_ERROR: "FETCH_WORKSPACE_ERROR",
  FETCH_WORKSPACES_ERROR: "FETCH_WORKSPACES_ERROR",
  CREATE_WORKSPACE_ERROR: "CREATE_WORKSPACE_ERROR",
  ADD_USER_TO_WORKSPACE_ERROR: "ADD_USER_TO_WORKSPACE_ERROR",
  FETCH_USER_APPLICATIONS_WORKSPACES_ERROR:
    "FETCH_USER_APPLICATIONS_WORKSPACES_ERROR",
  FETCH_WORKSPACE_ENTITIES_ERROR: "FETCH_WORKSPACE_ENTITIES_ERROR",
  FETCH_ALL_USERS_ERROR: "FETCH_ALL_USERS_ERROR",
  FETCH_ALL_ROLES_ERROR: "FETCH_ALL_ROLES_ERROR",
  DELETE_WORKSPACE_USER_ERROR: "DELETE_WORKSPACE_USER_ERROR",
  DELETE_WORKSPACE_ERROR: "DELETE_WORKSPACE_ERROR",
  SEARCH_WORKSPACE_ENTITIES_ERROR: "SEARCH_WORKSPACE_ENTITIES_ERROR",
  FETCH_ALL_APPLICATIONS_OF_WORKSPACE_ERROR:
    "FETCH_ALL_APPLICATIONS_OF_WORKSPACE_ERROR",
};

const CurlImportActionTypes = {
  SET_CURL_MODAL_OPEN: "SET_CURL_MODAL_OPEN",
  SET_CURL_MODAL_CLOSE: "SET_CURL_MODAL_CLOSE",
  SUBMIT_CURL_FORM_INIT: "SUBMIT_CURL_FORM_INIT",
  SUBMIT_CURL_FORM_SUCCESS: "SUBMIT_CURL_FORM_SUCCESS",
};

const CurlImportActionErrorTypes = {
  SUBMIT_CURL_FORM_ERROR: "SUBMIT_CURL_FORM_ERROR",
};

const GeneratePageActionTypes = {
  SET_GENERATE_PAGE_MODAL_OPEN: "SET_GENERATE_PAGE_MODAL_OPEN",
  SET_GENERATE_PAGE_MODAL_CLOSE: "SET_GENERATE_PAGE_MODAL_CLOSE",
  SUBMIT_GENERATE_PAGE_FORM_INIT: "SUBMIT_GENERATE_PAGE_FORM_INIT",
  SUBMIT_GENERATE_PAGE_FORM_SUCCESS: "SUBMIT_GENERATE_PAGE_FORM_SUCCESS",
};

const GeneratePageActionErrorTypes = {
  SUBMIT_GENERATE_PAGE_FORM_ERROR: "SUBMIT_GENERATE_PAGE_FORM_ERROR",
};

const BatchUpdateActionTypes = {
  BATCHED_UPDATE: "BATCHED_UPDATE",
  EXECUTE_BATCH: "EXECUTE_BATCH",
  BATCH_UPDATES_SUCCESS: "BATCH_UPDATES_SUCCESS",
};

const HelpActionTypes = {
  UPDATE_USER_INTERCOM_CONSENT: "UPDATE_USER_INTERCOM_CONSENT",
  SET_DEFAULT_REFINEMENT: "SET_DEFAULT_REFINEMENT",
  SET_HELP_MODAL_OPEN: "SET_HELP_MODAL_OPEN",
};

const AdminSettingsActionTypes = {
  FETCH_RELEASES_SUCCESS: "FETCH_RELEASES_SUCCESS",
  RESET_UNREAD_RELEASES_COUNT: "RESET_UNREAD_RELEASES_COUNT",
  FETCH_ADMIN_SETTINGS: "FETCH_ADMIN_SETTINGS",
  FETCH_ADMIN_SETTINGS_SUCCESS: "FETCH_ADMIN_SETTINGS_SUCCESS",
  FETCH_ADMIN_SETTINGS_ERROR: "FETCH_ADMIN_SETTINGS_ERROR",
  SAVE_ADMIN_SETTINGS: "SAVE_ADMIN_SETTINGS",
  SAVE_ADMIN_SETTINGS_SUCCESS: "SAVE_ADMIN_SETTINGS_SUCCESS",
  SAVE_ADMIN_SETTINGS_ERROR: "SAVE_ADMIN_SETTINGS_ERROR",
  DOWNLOAD_DOCKER_COMPOSE_FILE: "DOWNLOAD_DOCKER_COMPOSE_FILE",
  TOGGLE_RELEASE_NOTES: "TOGGLE_RELEASE_NOTES",
  FETCH_RELEASES: "FETCH_RELEASES",
  RESTART_SERVER_POLL: "RESTART_SERVER_POLL",
  RETRY_RESTART_SERVER_POLL: "RETRY_RESTART_SERVER_POLL",
  SEND_TEST_EMAIL: "SEND_TEST_EMAIL",
  UPLOAD_NAVIGATION_LOGO_INIT: "UPLOAD_NAVIGATION_LOGO_INIT",
  UPLOAD_NAVIGATION_LOGO_SUCCESS: "UPLOAD_NAVIGATION_LOGO_SUCCESS",
  DELETE_NAVIGATION_LOGO_INIT: "DELETE_NAVIGATION_LOGO_INIT",
  DELETE_NAVIGATION_LOGO_SUCCESS: "DELETE_NAVIGATION_LOGO_SUCCESS",
};

const AdminSettingsActionErrorTypes = {
  FETCH_RELEASES_ERROR: "FETCH_RELEASES_ERROR",
  RESTART_SERVER_ERROR: "RESTART_SERVER_ERROR",
  UPLOAD_NAVIGATION_LOGO_ERROR: "UPLOAD_NAVIGATION_LOGO_ERROR",
  DELETE_NAVIGATION_LOGO_ERROR: "DELETE_NAVIGATION_LOGO_ERROR",
};

const TemplateActionsTypes = {
  GENERATE_TEMPLATE_PAGE_INIT: "GENERATE_TEMPLATE_PAGE_INIT",
  GENERATE_TEMPLATE_PAGE_SUCCESS: "GENERATE_TEMPLATE_PAGE_SUCCESS",
  SET_CRUD_INFO_MODAL_OPEN: "SET_CRUD_INFO_MODAL_OPEN",
  GET_ALL_TEMPLATES_INIT: "GET_ALL_TEMPLATES_INIT",
  GET_ALL_TEMPLATES_SUCCESS: "GET_ALL_TEMPLATES_SUCCESS",
  UPDATE_TEMPLATE_FILTERS: "UPDATE_TEMPLATE_FILTERS",
  RESET_TEMPLATE_FILTERS: "RESET_TEMPLATE_FILTERS",
  SET_TEMPLATE_SEARCH_QUERY: "SET_TEMPLATE_SEARCH_QUERY",
  IMPORT_TEMPLATE_TO_APPLICATION_INIT: "IMPORT_TEMPLATE_TO_APPLICATION_INIT",
  IMPORT_TEMPLATE_TO_APPLICATION_SUCCESS:
    "IMPORT_TEMPLATE_TO_APPLICATION_SUCCESS",
  IMPORT_TEMPLATE_TO_WORKSPACE_INIT: "IMPORT_TEMPLATE_TO_WORKSPACE_INIT",
  IMPORT_TEMPLATE_TO_WORKSPACE_SUCCESS: "IMPORT_TEMPLATE_TO_WORKSPACE_SUCCESS",
  SET_TEMPLATE_NOTIFICATION_SEEN: "SET_TEMPLATE_NOTIFICATION_SEEN",
  GET_TEMPLATE_NOTIFICATION_SEEN: "GET_TEMPLATE_NOTIFICATION_SEEN",
  GET_SIMILAR_TEMPLATES_INIT: "GET_SIMILAR_TEMPLATES_INIT",
  GET_SIMILAR_TEMPLATES_SUCCESS:
    "GET_SIMILAR_TEMPLATES_SUCCESS" /* This action constants is for identifying the status of the updates of the entities */,
  GET_TEMPLATE_INIT: "GET_TEMPLATES_INIT",
  GET_TEMPLATE_SUCCESS: "GET_TEMPLATES_SUCCESS",
  SHOW_TEMPLATES_MODAL: "SHOW_TEMPLATES_MODAL",
  HIDE_TEMPLATES_MODAL: "HIDE_TEMPLATES_MODAL",
  SHOW_CREATE_APP_FROM_TEMPLATES_MODAL: "SHOW_CREATE_APP_FROM_TEMPLATES_MODAL",
  HIDE_CREATE_APP_FROM_TEMPLATES_MODAL: "HIDE_CREATE_APP_FROM_TEMPLATES_MODAL",
  GET_TEMPLATE_FILTERS_INIT: "GET_TEMPLATE_FILTERS_INIT",
  GET_TEMPLATE_FILTERS_SUCCESS: "GET_TEMPLATE_FILTERS_SUCCESS",
  PUBLISH_APP_AS_COMMUNITY_TEMPLATE_INIT:
    "PUBLISH_APP_AS_COMMUNITY_TEMPLATE_INIT",
  PUBLISH_APP_AS_COMMUNITY_TEMPLATE_SUCCESS:
    "PUBLISH_APP_AS_COMMUNITY_TEMPLATE_SUCCESS",
  SET_PUBLISHED_APP_TO_COMMUNITY_PORTAL:
    "SET_PUBLISHED_APP_TO_COMMUNITY_PORTAL",
  IMPORT_TEMPLATE_TO_APPLICATION_ONBOARDING_FLOW:
    "IMPORT_TEMPLATE_TO_APPLICATION_ONBOARDING_FLOW",
  IMPORT_TEMPLATE_TO_APPLICATION_ONBOARDING_FLOW_SUCCESS:
    "IMPORT_TEMPLATE_TO_APPLICATION_ONBOARDING_FLOW_SUCCESS",
  SET_ACTIVE_LOADING_TEMPLATE_ID: "SET_ACTIVE_LOADING_TEMPLATE_ID",
};

const TemplateActionErrorTypes = {
  GENERATE_TEMPLATE_PAGE_ERROR: "GENERATE_TEMPLATE_PAGE_ERROR",
  GET_ALL_TEMPLATES_ERROR: "GET_ALL_TEMPLATES_ERROR",
  GET_SIMILAR_TEMPLATES_ERROR: "GET_SIMILAR_TEMPLATES_ERROR",
  IMPORT_TEMPLATE_TO_ORGANISATION_ERROR:
    "IMPORT_TEMPLATE_TO_ORGANISATION_ERROR",
  IMPORT_TEMPLATE_TO_APPLICATION_ERROR: "IMPORT_TEMPLATE_TO_APPLICATION_ERROR",
  IMPORT_TEMPLATE_TO_WORKSPACE_ERROR: "IMPORT_TEMPLATE_TO_WORKSPACE_ERROR",
  GET_TEMPLATE_ERROR: "GET_TEMPLATE_ERROR",
  GET_TEMPLATE_FILTERS_ERROR: "GET_TEMPLATE_FILTERS_ERROR",
  PUBLISH_APP_AS_COMMUNITY_TEMPLATE_ERROR:
    "PUBLISH_APP_AS_COMMUNITY_TEMPLATE_ERROR",
  IMPORT_TEMPLATE_TO_APPLICATION_ONBOARDING_FLOW_ERROR:
    "IMPORT_TEMPLATE_TO_APPLICATION_ONBOARDING_FLOW_ERROR",
};

const TableWidgetActionsTypes = {
  SHOW_TABLE_FILTER_PANE: "SHOW_TABLE_FILTER_PANE",
  HIDE_TABLE_FILTER_PANE: "HIDE_TABLE_FILTER_PANE",
  TABLE_PANE_MOVED: "TABLE_PANE_MOVED",
};

const AppThemeActionsTypes = {
  SET_APP_THEMING_STACK: "SET_APP_THEMING_STACK",
  FETCH_APP_THEMES_INIT: "FETCH_APP_THEMES_INIT",
  FETCH_APP_THEMES_SUCCESS: "FETCH_APP_THEMES_SUCCESS",
  SET_DEFAULT_SELECTED_THEME_INIT: "SET_DEFAULT_SELECTED_THEME_INIT",
  FETCH_SELECTED_APP_THEME_INIT: "FETCH_SELECTED_APP_THEME_INIT",
  FETCH_SELECTED_APP_THEME_SUCCESS: "FETCH_SELECTED_APP_THEME_SUCCESS",
  UPDATE_SELECTED_APP_THEME_INIT: "UPDATE_SELECTED_APP_THEME_INIT",
  UPDATE_SELECTED_APP_THEME_SUCCESS: "UPDATE_SELECTED_APP_THEME_SUCCESS",
  CHANGE_SELECTED_APP_THEME_INIT: "CHANGE_SELECTED_APP_THEME_INIT",
  CHANGE_SELECTED_APP_THEME_SUCCESS: "CHANGE_SELECTED_APP_THEME_SUCCESS",
  SET_PREVIEW_APP_THEME: "SET_PREVIEW_APP_THEME",
  SAVE_APP_THEME_INIT: "SAVE_APP_THEME_INIT",
  DELETE_APP_THEME_INIT: "DELETE_APP_THEME_INIT",
  DELETE_APP_THEME_SUCCESS: "DELETE_APP_THEME_SUCCESS",
  RESET_APP_THEME_INIT: "RESET_APP_THEME_INIT",
  RESET_APP_THEME_SUCCESS: "RESET_APP_THEME_SUCCESS",
};

const AppThemeActionErrorTypes = {
  FETCH_APP_THEMES_ERROR: "FETCH_APP_THEMES_ERROR",
  SET_DEFAULT_SELECTED_THEME_ERROR: "SET_DEFAULT_SELECTED_THEME_ERROR",
  FETCH_SELECTED_APP_THEME_ERROR: "FETCH_SELECTED_APP_THEME_ERROR",
  UPDATE_SELECTED_APP_THEME_ERROR: "UPDATE_SELECTED_APP_THEME_ERROR",
  CHANGE_SELECTED_APP_THEME_ERROR: "CHANGE_SELECTED_APP_THEME_ERROR",
  DELETE_APP_THEME_ERROR: "DELETE_APP_THEME_ERROR",
};

const AppSettingsActionTypes = {
  UPDATE_APP_SETTINGS_PANE_SELECTED_TAB:
    "UPDATE_APP_SETTINGS_PANE_SELECTED_TAB",
};

const OrganizationActionTypes = {
  FETCH_CURRENT_ORGANIZATION_CONFIG: "FETCH_CURRENT_ORGANIZATION_CONFIG",
  FETCH_CURRENT_ORGANIZATION_CONFIG_SUCCESS:
    "FETCH_CURRENT_ORGANIZATION_CONFIG_SUCCESS",
  UPDATE_ORGANIZATION_CONFIG: "UPDATE_ORGANIZATION_CONFIG",
  UPDATE_ORGANIZATION_CONFIG_SUCCESS: "UPDATE_ORGANIZATION_CONFIG_SUCCESS",
  FETCH_PRODUCT_ALERT_INIT: "FETCH_PRODUCT_ALERT_INIT",
  FETCH_PRODUCT_ALERT_SUCCESS: "FETCH_PRODUCT_ALERT_SUCCESS",
  UPDATE_PRODUCT_ALERT_CONFIG: "UPDATE_PRODUCT_ALERT_CONFIG",
  FETCH_MY_ORGANIZATIONS_INIT: "FETCH_MY_ORGANIZATIONS_INIT",
  FETCH_MY_ORGANIZATIONS_SUCCESS: "FETCH_MY_ORGANIZATIONS_SUCCESS",
};

const OrganizationActionErrorTypes = {
  FETCH_CURRENT_ORGANIZATION_CONFIG_ERROR:
    "FETCH_CURRENT_ORGANIZATION_CONFIG_ERROR",
  UPDATE_ORGANIZATION_CONFIG_ERROR: "UPDATE_ORGANIZATION_CONFIG_ERROR",
  FETCH_PRODUCT_ALERT_FAILED: "FETCH_PRODUCT_ALERT_FAILED",
  FETCH_MY_ORGANIZATIONS_ERROR: "FETCH_MY_ORGANIZATIONS_ERROR",
};

const AnalyticsActionTypes = {
  SEGMENT_INITIALIZED: "SEGMENT_INITIALIZED",
  SEGMENT_INIT_UNCERTAIN: "SEGMENT_INIT_UNCERTAIN",
  SET_BUILDING_BLOCK_DRAG_START_TIME: "SET_BUILDING_BLOCK_DRAG_START_TIME",
  RESET_BUILDING_BLOCK_DRAG_START_TIME: "RESET_BUILDING_BLOCK_DRAG_START_TIME",
  SEND_ANALYTICS_FOR_SIDE_BY_SIDE_HOVER:
    "SEND_ANALYTICS_FOR_SIDE_BY_SIDE_HOVER",
  RECORD_ANALYTICS_FOR_SIDE_BY_SIDE_WIDGET_HOVER:
    "RECORD_ANALYTICS_FOR_SIDE_BY_SIDE_WIDGET_HOVER",
  RECORD_ANALYTICS_FOR_SIDE_BY_SIDE_NAVIGATION:
    "RECORD_ANALYTICS_FOR_SIDE_BY_SIDE_NAVIGATION",
  RESET_ANALYTICS_FOR_SIDE_BY_SIDE_HOVER:
    "RESET_ANALYTICS_FOR_SIDE_BY_SIDE_HOVER",
};

const OneClickBindingActionTypes = {
  FETCH_GSHEET_SPREADSHEETS: "FETCH_GSHEET_SPREADSHEETS",
  FETCH_GSHEET_SPREADSHEETS_SUCCESS: "FETCH_GSHEET_SPREADSHEETS_SUCCESS",
  FETCH_GSHEET_SPREADSHEETS_FAILURE: "FETCH_GSHEET_SPREADSHEETS_FAILURE",
  FETCH_GSHEET_SHEETS: "FETCH_GSHEET_SHEETS",
  FETCH_GSHEET_SHEETS_SUCCESS: "FETCH_GSHEET_SHEETS_SUCCESS",
  FETCH_GSHEET_SHEETS_FAILURE: "FETCH_GSHEET_SHEETS_FAILURE",
  FETCH_GSHEET_COLUMNS: "FETCH_GSHEET_COLUMNS",
  FETCH_GSHEET_COLUMNS_SUCCESS: "FETCH_GSHEET_COLUMNS_SUCCESS",
  FETCH_GSHEET_COLUMNS_FAILURE: "FETCH_GSHEET_COLUMNS_FAILURE",
  BIND_WIDGET_TO_DATASOURCE: "BIND_WIDGET_TO_DATASOURCE",
  BIND_WIDGET_TO_DATASOURCE_SUCCESS: "BIND_WIDGET_TO_DATASOURCE_SUCCESS",
  BIND_WIDGET_TO_DATASOURCE_ERROR: "BIND_WIDGET_TO_DATASOURCE_ERROR",
  SET_ONE_CLICK_BINDING_OPTIONS_VISIBILITY:
    "SET_ONE_CLICK_BINDING_OPTIONS_VISIBILITY",
};

const AIActionTypes = {
  UPDATE_AI_CONTEXT: "UPDATE_AI_CONTEXT",
  UPDATE_AI_TRIGGERED: "UPDATE_AI_TRIGGERED",
};

const PlatformActionErrorTypes = {
  API_ERROR: "API_ERROR",
};

export const ReduxActionTypes = {
  ...ActionActionTypes,
  ...AdminSettingsActionTypes,
  ...AnalyticsActionTypes,
  ...AIActionTypes,
  ...ApplicationActionTypes,
  ...AppThemeActionsTypes,
  ...AppViewActionTypes,
  ...AppSettingsActionTypes,
  ...BatchUpdateActionTypes,
  ...BuildingBlocksActionTypes,
  ...CurlImportActionTypes,
  ...DatasourceEditorActionTypes,
  ...ErrorManagementActionTypes,
  ...ExplorerActionTypes,
  ...EvaluationActionTypes,
  ...FeatureFlagActionTypes,
  ...GeneratePageActionTypes,
  ...GitActionTypes,
  ...HelpActionTypes,
  ...IDEActionTypes,
  ...IDEDebuggerActionTypes,
  ...ImportGitActionTypes,
  ...ImportExportActionTypes,
  ...JSLibraryActionTypes,
  ...JSEditorActionTypes,
  ...OnboardingActionTypes,
  ...OneClickBindingActionTypes,
  ...OmniSearchActionTypes,
  ...PageActionTypes,
  ...PluginActionTypes,
  ...PropertyPanelActionTypes,
  ...ResourceMapActionTypes,
  ...SnippingModeActionTypes,
  ...TableWidgetActionsTypes,
  ...TemplateActionsTypes,
  ...OrganizationActionTypes,
  ...ThemeActionTypes,
  ...UserAuthActionTypes,
  ...UserProfileActionTypes,
  ...WidgetCanvasActionTypes,
  ...WidgetOperationsActionTypes,
  ...WorkspaceActionTypes,
} as const;

export const ReduxActionErrorTypes = {
  ...ActionActionErrorTypes,
  ...AdminSettingsActionErrorTypes,
  ...AppThemeActionErrorTypes,
  ...ApplicationActionErrorTypes,
  ...AppViewActionErrorTypes,
  ...BuildingBlocksActionErrorTypes,
  ...CurlImportActionErrorTypes,
  ...DatasourceEditorActionErrorTypes,
  ...EvaluationActionErrorTypes,
  ...FeatureFlagActionErrorTypes,
  ...GeneratePageActionErrorTypes,
  ...GitActionErrorTypes,
  ...IDEActionErrorTypes,
  ...ImportExportActionErrorTypes,
  ...JSEditorActionErrorTypes,
  ...JSLibraryActionErrorTypes,
  ...PageActionErrorTypes,
  ...PlatformActionErrorTypes,
  ...PluginActionErrorTypes,
  ...TemplateActionErrorTypes,
  ...OrganizationActionErrorTypes,
  ...UserAuthActionErrorTypes,
  ...UserProfileActionErrorTypes,
  ...WidgetCanvasActionErrorTypes,
  ...WidgetOperationActionErrorTypes,
  ...WorkspaceActionErrorTypes,
};

export const toastMessageErrorTypes = {
  ...AdminSettingsActionErrorTypes,
  ...ApplicationActionErrorTypes,
  ...AppViewActionErrorTypes,
  ...DatasourceEditorActionErrorTypes,
  ...GitActionErrorTypes,
  ...ImportExportActionErrorTypes,
  ...PlatformActionErrorTypes,
  ...OrganizationActionErrorTypes,
  ...UserAuthActionErrorTypes,
  ...UserProfileActionErrorTypes,
  ...WorkspaceActionErrorTypes,
};

export type ReduxActionErrorType =
  (typeof ReduxActionErrorTypes)[keyof typeof ReduxActionErrorTypes];

export const ReduxFormActionTypes = {
  VALUE_CHANGE: "@@redux-form/CHANGE",
  ARRAY_REMOVE: "@@redux-form/ARRAY_REMOVE",
  ARRAY_PUSH: "@@redux-form/ARRAY_PUSH",
};

export const WidgetReduxActionTypes: { [key: string]: string } = {
  WIDGET_ADD_CHILD: "WIDGET_ADD_CHILD",
  WIDGET_CHILD_ADDED: "WIDGET_CHILD_ADDED",
  WIDGET_REMOVE_CHILD: "WIDGET_REMOVE_CHILD",
  WIDGET_RESIZE: "WIDGET_RESIZE",
  WIDGET_MODAL_RESIZE: "WIDGET_MODAL_RESIZE",
  WIDGET_DELETE: "WIDGET_DELETE",
  WIDGET_BULK_DELETE: "WIDGET_BULK_DELETE",
  WIDGET_SINGLE_DELETE: "WIDGET_SINGLE_DELETE",
  WIDGET_UPDATE_PROPERTY: "WIDGET_UPDATE_PROPERTY",
};
